import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Validators } from '@angular/forms';
import { MatTableDataSource } from '@angular/material';

import { AppService } from 'projects/messages/src/app/app.service';
import { IceNavService } from 'projects/icemedx-lib/src/components/ice-nav/ice-nav.service';
import { MessageService } from 'projects/icemedx-lib/src/services/message/message.service';
import { DomainService, IConsentListItem, ConsentListObject } from 'projects/icemedx-lib/src/services/domain/domain.service';
import { LoginService } from 'projects/icemedx-lib/src/login/login.service';
import { userTypes } from 'projects/icemedx-lib/src/login/login.config';
import { GoogleService } from 'projects/icemedx-lib/src/services/google/google.service';
import { ProviderService } from '../../../../icemedx-lib/src/services/provider/provider.service';
import { PatientService } from '../../../../icemedx-lib/src/services/patient/patient.service';
import { OrderService } from '../../../../icemedx-lib/src/services/orders/order.service';
import { ScheduleService } from '../../../../icemedx-lib/src/services/schedule/schedule.service';
import { VendorService } from '../../../../icemedx-lib/src/services/vendor/vendor.service';

import {
  IcecontrolSettings,
  IcemattableSettings,
  iceColumnDefinition,
  IcepanelgroupSettings,
  IcepanelsectionSettings,
  IcepanelSettings,
  IceexpansionpanelSettings,
  IcepanelcontainerSettings,
  IcepanelcontainerRowSettings,
  SECTION_CONTROL_ALIGNMENT
} from 'projects/icemedx-lib/src/components/models/icesettings';
import { Iceutility } from 'projects/icemedx-lib/src/services/iceutility';
import { IceTypes } from 'projects/icemedx-lib/src/models/icetypes';

import { message } from 'projects/icemedx-lib/src/models/messages/message';
import { consentreference } from 'projects/icemedx-lib/src/models/domain/consentreference';
import { user } from '../../../../icemedx-lib/src/models/common/user';
import { managementguideline } from '../../../../icemedx-lib/src/models/ehr/subs/managementguideline';
import { subtypereference } from '../../../../icemedx-lib/src/models/ehr/subs/subtypereference';
import { observation } from '../../../../icemedx-lib/src/models/ehr/subs/observation';
import { alert } from '../../../../icemedx-lib/src/models/system/alert';
import { patient } from '../../../../icemedx-lib/src/models/domain/patient';
import { entity } from '../../../../icemedx-lib/src/models/common/entity';
import { contact } from '../../../../icemedx-lib/src/models/common/contact';
import { address } from '../../../../icemedx-lib/src/models/common/address';
import { identification } from '../../../../icemedx-lib/src/models/common/identification';
import { provider } from '../../../../icemedx-lib/src/models/domain/provider';
import { provider_index } from '../../../../icemedx-lib/src/models/domain/provider_index';
import { provider_reference } from '../../../../icemedx-lib/src/models/domain/provider_reference';
import { appointment } from '../../../../icemedx-lib/src/models/schedule/appointment';
import { calendar } from '../../../../icemedx-lib/src/models/schedule/calendar';
import { day } from '../../../../icemedx-lib/src/models/schedule/day';
import { slot } from '../../../../icemedx-lib/src/models/schedule/slot';
import { externaldata } from '../../../../icemedx-lib/src/models/ehr/externaldata';
import { vendor } from '../../../../icemedx-lib/src/models/domain/vendor';
import { pharmacy } from '../../../../icemedx-lib/src/models/domain/pharmacy';
import { payer } from '../../../../icemedx-lib/src/models/domain/payer';
import { PharmacyService } from '../../../../icemedx-lib/src/services/pharmacy/pharmacy.service';
import { PayerService } from '../../../../icemedx-lib/src/services/payer/payer.service';
import { subscriber } from '../../../../icemedx-lib/src/models/domain/subscriber';
import { medicalservice } from '../../../../icemedx-lib/src/models/accounting/medservice/medicalservice';
import { superbillcharges } from '../../../../icemedx-lib/src/models/accounting/medservice/superbillcharges';
import { AccountingService } from '../../../../icemedx-lib/src/services/accounting/accounting.service';
import { payer_index } from '../../../../icemedx-lib/src/models/domain/payer_index';
import { MedicalcodesService } from '../../../../icemedx-lib/src/services/medicalcodes/medicalcodes.service';

const ForwardMessage: string = "ForwardMessage";
const ReplyMessage: string = "ReplyMessage";
const ReplyAllMessage: string = "ReplyAllMessage";
const CancelMessage: string = "CancelMessage";
const ResetMessage: string = "ResetMessage";
const AcceptMessage: string = "AcceptMessage";
const EditMessage: string = "AcceptMessage";
const DeclineInvite: string = "DeclineInvite";
const TentativeInvite: string = "TentativeInvite";
const JoinInvite: string = "JoinInvite";
const SubmitSurvey: string = "SubmitSurvey";
const Recaptcha: string = "Recaptcha";
const SurveyStatus: string = "SurveyStatus";
const MessageStatus: string = "MessageStatus";
const CurrentStatusDescription: string = "CurrentStatusDescription";
const StatusDescription: string = "StatusDescription";
const AddNewContinue = "AddNewContinue";
const ImportContinue = "ImportContinue";
const AppointmentContinue = "AppointmentContinue";
const NewRequestForAppointment = "NewRequestForAppointment"
const BillingContinue = "BillingContinue";
const NewRequestForBenefits = "NewRequestForBenefits"

// appointment
const DateOfAppointment = "DateOfAppointment";
const TimeOfAppointment = "TimeOfAppointment";
const TelehealthAppointment = "TelehealthAppointment";
const TelehealthUrlForAppointment = "TelehealthUrlForAppointment";
const AppointmentHeaderSection = "AppointmentHeaderSection";
const BillingHeaderSection = "BillingHeaderSection";

declare var require: any;
let currentEnv: any = require("../../../../../env.json").currentEnv;

@Component({
  selector: 'viewmessage',
  templateUrl: './viewmessage.component.html',
  styleUrls: ['./viewmessage.component.scss'],
  providers: [IceNavService, AppService]
})
export class ViewmessageComponent implements OnInit {
  // Data member
  messageObj: message = new message();
  defaultConsents: consentreference[] = null;
  consentDataSource: MatTableDataSource<IConsentListItem> = new MatTableDataSource<IConsentListItem>([]);
  consentAcceptedDataSource: MatTableDataSource<consentreference> = new MatTableDataSource<consentreference>([]);
  attachmentsDataSource: MatTableDataSource<externaldata> = new MatTableDataSource<any>([]);
  attachmentMap: any = {};
  dropzoneAttachmentCtrl: IcecontrolSettings = new IcecontrolSettings(
    "icedragdrop",
    {
      acceptedFiles: '.jpg, .png, .txt, .pdf, .xls, .doc, .docx',
      infoText: "Use the area below to upload document attachments (i.e. Legal documents and Identification)."
    }, null, null,
    "",
    "Drop files here to upload"
  );

  loading: boolean = true;
  memberIsFirstRecipient: boolean = false;

  // Member settings
  messageSettings: IcepanelcontainerSettings = null;
  patientToAdd: patient = null;
  providerToAdd: provider = null;
  domainToAdd: any = {
    "vendorHIE": null,
    "pharmacy" : null, 
    "payer": null,
    "subscriber": null,
  };

  appointmentsToManage: appointment[] = null;
  billsToManage: superbillcharges[] = null;
  private loaderSection: IcepanelsectionSettings = null;
  private surverySectionDisplayMap = {
    account_type: "Doctor/Organization",
    organization_name: "Organization Name",
    first_name: "First Name",
    last_name: "Last Name",
    initial: "Initial",
    additional_name: "Additional Name",
    country: "Country",
    dob: "Date of Birth",
    sex: "Sex",
    identification_code: "Identification Code",
    phone: "Phone",
    street1: "Street 1",
    street2: "Street 2",
    city: "City",
    state_id: "State",
    postal_code: "Postal Code"
  };
  private countries: any[] = [];
  private dateFormat = Iceutility.getCurrentDateFormat();
  private dobControl: IcecontrolSettings = null;
  private controls: any[] = [];

  showDemo: boolean = false;

  constructor(private appSvc: AppService,
    private navSvc: IceNavService,
    private loginSvc: LoginService,
    private domainSvc: DomainService,
    private medCodeService: MedicalcodesService,
    private messageService: MessageService,
    private googleService: GoogleService,
    private ptService: PatientService, 
    private proService: ProviderService, 
    private schService: ScheduleService, 
    private venService: VendorService,
    private pharmService: PharmacyService,
    private payerService: PayerService,
    private acctService: AccountingService,
    private router: Router,
    private activatedRoute: ActivatedRoute) {

    this.appSvc.defaultMenus();

    this.appSvc.addBreadcrumb("Messages", {}, true, "");

    this.activatedRoute.params.subscribe(next => {
      if (next == null || next.key == "0" || next.length == 0) {
        this.messageSettings = this.viewSetup(null);
      }
      else {
        this.messageService.getMessage(next.key).subscribe(
          data => {
            if (data && data.length > 0 && data[0] != null) {
              let msg = <message>data[0];
              this.messageSettings = this.viewSetup(msg);
              this.postSetup(msg);
            }
          },
          error => {
            console.log(JSON.stringify(this.messageService.getLastErrors()));
          });
      }
    });
  }

  private updateMappedNames(msg: message) {
    if (msg == null) return;

    let fromUser = <user>DomainService.mappedMembers[msg.from.toLowerCase()],
      toUsers = msg.to.split(",");

    msg["_from"] = fromUser ? fromUser.getdisplayname() : msg.from;
    let toRecipientNames = [];
    for (let i = 0; i < toUsers.length; i++) {
      let toRecipient = toUsers[i].trim(),
        toUser = <user>DomainService.mappedMembers[toRecipient.toLowerCase()];

      toRecipientNames.push(toUser ? toUser.getdisplayname() : toRecipient);
    }
    msg["_to"] = toRecipientNames.join(", ");

    let panels = this.messageSettings.rows[0].columns.filter((panel) => panel.panelKey == msg.message_key);
    if (panels.length > 0) {
      panels[0].sections.forEach((sec) => {
        if (sec.controls != null) {
          let ctrls = sec.controls.filter(ctrl => ctrl.id == "FromMember");
          if (ctrls.length > 0) {
            ctrls[0].properties.value = "From: " + msg["_from"];
          }
          ctrls = sec.controls.filter(ctrl => ctrl.id == "ToMembers");
          if (ctrls.length > 0) {
            ctrls[0].properties.value = "To: " + msg["_to"];
          }
        }
      });
    }

    if (this.messageObj.CONSENTS.length > 0) {
      for (let icon = 0; icon < this.messageObj.CONSENTS.length; icon++) {
        if (this.messageObj.CONSENTS[icon].full_name.length == 0) {
          let memid = this.messageObj.CONSENTS[icon].login_user_name;
          let usr: user = DomainService.mappedMembers[memid.toLocaleLowerCase()];
          if (usr) this.messageObj.CONSENTS[icon].full_name = usr.getdisplayname();
        }

        if (!Iceutility.isTextDateTime(this.messageObj.CONSENTS[icon].date_of_consent))
          this.messageObj.CONSENTS[icon].date_of_consent = Iceutility.getDateTextEx(Iceutility.ConvertFromDotNetServerTime(this.messageObj.CONSENTS[icon].date_of_consent), null, true);
      }
    }
  }

  private postSetup(msg: message): void {
    let membersToMap = {};
    let mems = (msg.from + "," + msg.to).split(",");
    for (let imem = 0; imem < mems.length; imem++) {
      let tempmemid = mems[imem].toLowerCase();
      let mappedMember: user = <user>DomainService.mappedMembers[tempmemid];
      if (mappedMember == null) {
        membersToMap[tempmemid] = null;
      }
    }

    mems = Object.keys(membersToMap);
    if (mems.length > 0) {
      this.domainSvc.mapMembers(mems.join(",")).subscribe(
        data => {
          this.updateMappedNames(msg);
        },
        error => {
          this.updateMappedNames(msg);
          console.log(JSON.stringify(this.domainSvc.getLastErrors()));
        });
    }
    else {
      this.updateMappedNames(msg);
    }
  }

  private createsubtype(title: string, val: string, subtype: number, typeofrange: IceTypes.TYPEOFRANGE = IceTypes.TYPEOFRANGE.torInside): subtypereference {
    let ret: subtypereference = null;
    try {
      ret = new subtypereference();
      ret.sub_type_reference_key = Iceutility.guid(true);
      ret.auto_transcription = title;
      ret.type_lower_limit = val;
      ret.sub_type = subtype;
      ret.type_of_range = typeofrange;
    }
    catch (e) {
      console.log(e);
    }
    return ret;
  }

  private createobservation(title: string, id: string, val: string, rstatus: IceTypes.RESULT_STATUS = IceTypes.RESULT_STATUS.rsPreliminary, valueType: string = ""): observation {
    let ret: observation = null;
    try {
      ret = new observation();
      ret.observation_key = Iceutility.guid(true);
      ret.description = title;
      ret.obx4_observation_subid = id;
      ret.obx5_observation_value = val;
      ret.obx11_observation_result_status = rstatus;
      ret.obx2_value_type = valueType;
    }
    catch (e) {
      console.log(e);
    }
    return ret;
  }

  private showTermsSection(readonly: boolean): IcepanelsectionSettings {   
    let termsSection: IcepanelsectionSettings = null;
    try {
      let chkCtrl: IcecontrolSettings = readonly ? new IcecontrolSettings("icelabel", { width: "250px" }, null, null)
        .setControlName() :
        new IcecontrolSettings("icecheckbox", { width: "50px", cursor: 'pointer' }, null, null, null)
          .setControlName()
          .createFormControl(false, [Validators.required]);

      let termsTables: IcemattableSettings[] = [        
        new IcemattableSettings(
          "ConsentTable",
          [
            new iceColumnDefinition("agree", "", false, false, chkCtrl),
            new iceColumnDefinition("full_name", "I", false, false,
              new IcecontrolSettings("icelabel", { width: "75px" }, null, null)),
            new iceColumnDefinition("title_of_terms", "Agree To", false, false,
              new IcecontrolSettings("icelabel", { width: "100px", cursor: 'pointer' }, null, null)),
            new iceColumnDefinition("date_of_consent", "Date", false, false,
              new IcecontrolSettings("icelabel", { width: "100px" }, null, null)),
            new iceColumnDefinition("status", "Status", false),
            new iceColumnDefinition("external_data_key", "external_data_key", false, true),
            new iceColumnDefinition("key", "Key", true),
          ],
          this.consentDataSource,
          [],
          false,
          null,
          true
        )
      ];
      let termsGroups: IcepanelgroupSettings[] = [
        new IcepanelgroupSettings(null, termsTables)
      ];

      termsSection = new IcepanelsectionSettings("TermsSection", { class: [], styles: { width: "100%" } }, termsGroups, [], null);
    }
    catch (e) {
      console.log(e);
    }
    return termsSection;
  }

  private showAcceptedTermsSection() {
    let acceptedTermsSection: IcepanelsectionSettings = null;
    try {
      let termsTables: IcemattableSettings[] = [
        new IcemattableSettings(
          "AcceptConsentTable",
          [
            new iceColumnDefinition("full_name", "Accepted Term(s)", false, false,
              new IcecontrolSettings("icelabel", { width: "75px" }, null, null)),
            new iceColumnDefinition("title", "", false, false,
              new IcecontrolSettings("icelabel", { width: "100px", cursor: 'pointer' }, null, null)),
            new iceColumnDefinition("date_of_consent", "", false, false,
              new IcecontrolSettings("icelabel", { width: "100px" }, null, null)),
            new iceColumnDefinition("external_data_key", "external_data_key", false, true),
            new iceColumnDefinition("consent_reference_key", "Key", true),
          ],
          this.consentAcceptedDataSource,
          [],
          false,
          null,
          true
        )
      ];
      let termsGroups: IcepanelgroupSettings[] = [
        new IcepanelgroupSettings(null, termsTables)
      ];

      acceptedTermsSection = new IcepanelsectionSettings("AcceptedTermsSection", { class: [], styles: { width: "100%" } }, termsGroups, [], null);
    }
    catch (e) {
      console.log(e);
    }
    return acceptedTermsSection;
  }

  private showDropZone() {
    let dropzonSection: IcepanelsectionSettings = null;
    try {
      this.dropzoneAttachmentCtrl.properties.url = this.messageService.getMessageFileUploadUri(this.appSvc.getCurrentAccount(), this.appSvc.getCurrentAccountType(), this.messageObj.message_key, "", IceTypes.SourceType.srcMiscellaneousForms);
      this.dropzoneAttachmentCtrl.properties.headers = { 'Authorization': 'Bearer ' + this.loginSvc.GetAccessToken(this.loginSvc.GetSessionUserInfo()) };

      dropzonSection = new IcepanelsectionSettings("DropZoneSection", { class: [], styles: { width: "100%" } }, null, [
        this.dropzoneAttachmentCtrl
      ], null);
    }
    catch (e) {
      console.log(e);
    }
    return dropzonSection;
  }

  private showAttachments() {
    let attachmentSection = null;
    try {
      let tables: IcemattableSettings[] = [
        new IcemattableSettings(
          "AttachmentsTable",
          [
            new iceColumnDefinition("title", "Attachment(s)", false, false),
            new iceColumnDefinition("external_data_key", "", true, true)
          ],
          this.attachmentsDataSource,
          [],
          true,
          null
        )
      ];

      attachmentSection = new IcepanelsectionSettings("AttachmentSection", { class: [""], styles: { width: "100%" } }, null, null, tables)
        .setControlAlignment(SECTION_CONTROL_ALIGNMENT.ctrlAlignVertical);
    }
    catch (e) {
      console.log(e);
    }
    return attachmentSection;
  }
  private loadDefaultTerms(useFromMember) {
    try{
      this.domainSvc.getDefaultConsents().subscribe(
        data => {
          if (data == null) {
            this.messageService.logMessage(IceTypes.LOGTYPE.ltFatal, "Failed to load user consents");
            return;
          }

          let fullname = "";
          let memid = "";
          if (useFromMember) {
            memid = this.messageObj.from;
            let mappedMember: user = <user>DomainService.mappedMembers[memid.toLowerCase()];
            if (mappedMember != null) {
              fullname = mappedMember.getdisplayname();
            }
          }
          else {
            let userInfo = this.loginSvc.GetSessionUserInfo();
            if (userInfo) {
              fullname = userInfo.Name;
              memid = userInfo.Username;
            }
          }
          this.defaultConsents = data;
          let dat: ConsentListObject[] = [];
          for (let i = 0; i < data.length; i++) {
            let cons: consentreference = data[i];
            if (cons == null) continue;

            let found = this.messageObj.CONSENTS.filter(c => c.code == cons.code && c.login_user_name == cons.login_user_name);
            if (found.length > 0) {

              let foundCon = found[0];
              dat.push(new ConsentListObject(foundCon.consent_reference_key, foundCon.external_data_key, memid, fullname, foundCon.title, "Required"));
              continue;
            }

            dat.push(new ConsentListObject(cons.consent_reference_key, cons.external_data_key, memid, fullname, cons.title, "Required"));
          }

          this.consentDataSource.data = dat;
        },
        error => {
          console.log(JSON.stringify(this.domainSvc.getLastErrors()));
        });
    }
    catch (e) {
      console.log(e);
    }
  }

  private showSureveySections(observs: observation[], status: IceTypes.orderentrystatus): IcepanelsectionSettings[] {
    let surveySections: IcepanelsectionSettings[] = [];
    try {

      surveySections.push(
        new IcepanelsectionSettings("SurveySection", { class: ["yalla"], styles: { width: "100%" } }, [], [
          new IcecontrolSettings("icedivider", { width: "75px" }, null, null)
          ], null));

      for (let iob = 0; iob < observs.length; iob++) {
        let ob: observation = observs[iob];

        let controls: IcecontrolSettings[] = [];

        let answers = ob.SUBTYPES.map(s => { return { name: s.auto_transcription, value: s.type_lower_limit } });

        if (IceTypes.RESULT_STATUS.rsFinal == ob.obx11_observation_result_status) {
          controls.push(new IcecontrolSettings(ob.description.length == 0 ? "icedivider" : "icelabel", { value: ob.description, width: "75px" }, null, null));
        }
        else {

          let valCtrl = null;
          if (answers.length == 0) {
            if (IceTypes.orderentrystatus.oestatusWaiting == status
              || IceTypes.orderentrystatus.oestatusTransactionError == status) {
              if (ob.obx4_observation_subid === "dob") {
                this.dobControl = new IcecontrolSettings("icedatepicker", { width: "325px", dateFormat: this.dateFormat }, null, null, ob.obx4_observation_subid, ob.description)
                  .setControlName(ob.obx4_observation_subid)
                  .createFormControl(ob.obx5_observation_value, IceTypes.RESULT_STATUS.rsNotObserved == ob.obx11_observation_result_status ? null : [Validators.required]);

                this.dobControl.createChangeControlEvent().subscribe(
                  event => {
                    console.log("change via create control event");
                    this.onControlChange(event);
                  },
                  error => { }
                );

                valCtrl = this.dobControl;
              } else {
                valCtrl = new IcecontrolSettings("iceinput", { width: "325px" }, null, null, ob.obx4_observation_subid, ob.description)
                  .setControlName(ob.obx4_observation_subid)
                  .createFormControl(ob.obx5_observation_value, IceTypes.RESULT_STATUS.rsNotObserved == ob.obx11_observation_result_status ? null : [Validators.required]);
              }
            }
            else {
              // Readonly
              let val = ob.obx5_observation_value;
              if (ob.obx4_observation_subid == "dob") {
                val = new Date(ob.obx5_observation_value).toLocaleDateString();
              }

              valCtrl = new IcecontrolSettings("icelabel", { value: this.surverySectionDisplayMap[ob.obx4_observation_subid] + ": " + val, width: "250px" }, null, null, ob.obx4_observation_subid, "Answer")
                .setControlName(ob.obx4_observation_subid);
            }
            controls.push(valCtrl);
          }
          else {
            if (IceTypes.orderentrystatus.oestatusWaiting == status
              || IceTypes.orderentrystatus.oestatusTransactionError == status) {
              if (ob.obx2_value_type.length == 0 || ob.obx2_value_type == "iceselect") controls.push(new IcecontrolSettings("icelabel", { value: ob.description, width: "75px" }, null, null));
              valCtrl = new IcecontrolSettings(ob.obx2_value_type.length == 0 ? "iceselect" : ob.obx2_value_type, { menuItems: answers, width: "250px" }, null, null, ob.obx4_observation_subid + ob.observation_key, ob.obx2_value_type.length == 0 || ob.obx2_value_type == "iceselect" ? "Answer" : ob.description)
                .setControlName(ob.obx4_observation_subid)
                .createFormControl(ob.obx5_observation_value, IceTypes.RESULT_STATUS.rsNotObserved == ob.obx11_observation_result_status ? null : [Validators.required]);

              valCtrl.setOptions(answers);
            }
            else {
              // Readonly
              let val = ob.obx5_observation_value;
              if (ob.obx4_observation_subid == "account_type") {
                // To do: This maybe should include vendors, payers, pharmacies
                if (<IceTypes.ACCOUNT_TYPE>Iceutility.toLong(ob.obx5_observation_value) == IceTypes.ACCOUNT_TYPE.actFacility)
                  val = "Organization or Facility";
                else if (<IceTypes.ACCOUNT_TYPE>Iceutility.toLong(ob.obx5_observation_value) == IceTypes.ACCOUNT_TYPE.actProvider) {
                  val = "Individual doctor";
                }
              }
              else if (ob.obx2_value_type == "iceautocomplete") {
                try {
                  let selected = JSON.parse(val);
                  if (selected != null && selected.length > 0) {
                    val = selected[0]["name"];  
                  }
                }
                catch (ob_e) {
                  // fall through
                }
              }
              if (ob.obx4_observation_subid == "country") {
                let foundCountry = this.countries.filter(c => c.value === ob.obx5_observation_value);
                if (Iceutility.isdefined(foundCountry) && foundCountry.length > 0) {
                  val = foundCountry[0]["name"];
                }
              }

              valCtrl = new IcecontrolSettings("icelabel", { value: this.surverySectionDisplayMap[ob.obx4_observation_subid] + ": " + val, width: "250px" }, null, null, ob.obx4_observation_subid, "Answer")
                .setControlName(ob.obx4_observation_subid);
            }
            controls.push(valCtrl);
          }
        }

        let questionSection = new IcepanelsectionSettings("SurveySection", { class: [""], styles: { width: "100%" } }, [], controls, null)
          .setControlAlignment(SECTION_CONTROL_ALIGNMENT.ctrlAlignVertical);
        surveySections.push(questionSection);
      }
    }
    catch (e) {
      console.log(e);
    }
    this.controls = surveySections;
    return surveySections;
  }

  private showSureveyHeading(gl: managementguideline, defDomainType: IceTypes.ACCOUNT_TYPE = IceTypes.ACCOUNT_TYPE.actNone, continueBtnText: string = "CONTINUE"): IcepanelsectionSettings[] {
    let surveySections: IcepanelsectionSettings[] = [];
    try {
      let controls: IcecontrolSettings[] = [];
      let completingActionSection = null;

      let usrInfo = this.loginSvc.GetSessionUserInfo();
      let to = this.messageObj.to.split(",");
      if (to.length > 0 && to[0].toLocaleLowerCase() == usrInfo.Username.toLocaleLowerCase()) {
        controls.push(new IcecontrolSettings("icelabel", { value: Iceutility.toLong(gl.order_status_type) == IceTypes.orderentrystatus.oestatusRendered ? "Submitted" : OrderService.getStatus(Iceutility.toLong(gl.order_status_type)), width: "250px" }, null, null, SurveyStatus + gl.management_guideline_key)
          .setControlName(SurveyStatus));
        if (!Iceutility.isStringUndefinedNullOrEmpty(gl.order_status_note)) {
          controls.push(new IcecontrolSettings("icelabel", { value: "Current Status Note:" + gl.order_status_note, width: "250px" }, null, null, CurrentStatusDescription)
            .setControlName(CurrentStatusDescription));
        }
      }
      else {
        let glstatuses = [
          { value: IceTypes.orderentrystatus.oestatusCancelled, name: OrderService.getStatus(IceTypes.orderentrystatus.oestatusCancelled) },
          { value: IceTypes.orderentrystatus.oestatusComplete, name: OrderService.getStatus(IceTypes.orderentrystatus.oestatusComplete) },
          { value: IceTypes.orderentrystatus.oestatusDenied, name: OrderService.getStatus(IceTypes.orderentrystatus.oestatusDenied) },
          { value: IceTypes.orderentrystatus.oestatusRendered, name: "Submitted" },
          { value: IceTypes.orderentrystatus.oestatusInprogress, name: OrderService.getStatus(IceTypes.orderentrystatus.oestatusInprogress) },
          { value: IceTypes.orderentrystatus.oestatusOnhold, name: OrderService.getStatus(IceTypes.orderentrystatus.oestatusOnhold) },
          { value: IceTypes.orderentrystatus.oestatusTransactionPending, name: OrderService.getStatus(IceTypes.orderentrystatus.oestatusTransactionPending) },
          { value: IceTypes.orderentrystatus.oestatusTransactionError, name: OrderService.getStatus(IceTypes.orderentrystatus.oestatusTransactionError) },
          { value: IceTypes.orderentrystatus.oestatusWaiting, name: OrderService.getStatus(IceTypes.orderentrystatus.oestatusWaiting) },
        ];

        if (currentEnv == "dev" || currentEnv == "qa") {
          glstatuses.push({ value: IceTypes.orderentrystatus.oestatusApproved, name: OrderService.getStatus(IceTypes.orderentrystatus.oestatusApproved) });
        }
        else {
          if (this.loginSvc.getHighestGroup(usrInfo, "*") > userTypes.USER_GROUPS.upGRT)
            glstatuses.push({ value: IceTypes.orderentrystatus.oestatusApproved, name: OrderService.getStatus(IceTypes.orderentrystatus.oestatusApproved) });
        }
        controls.push(new IcecontrolSettings("iceselect", {
          menuItems: glstatuses,
          width: "250px"
          }, null, null, SurveyStatus + gl.management_guideline_key, "Select Status")
          .setControlName(SurveyStatus)
          .createFormControl(Iceutility.toLong(gl.order_status_type), [Validators.required]));

        if (!Iceutility.isStringUndefinedNullOrEmpty(gl.order_status_note)) {
          controls.push(new IcecontrolSettings("icelabel", { value: "Current Status Note:" + gl.order_status_note, width: "250px" }, null, null, CurrentStatusDescription)
            .setControlName(CurrentStatusDescription));
        }
        controls.push(new IcecontrolSettings("iceinput", { width: "250px" }, null, null, StatusDescription, "Enter status of survey")
          .setControlName(StatusDescription)
          .createFormControl("", null));

        if (gl.trans_account.length == 0 && Iceutility.toLong(gl.order_status_type) == IceTypes.orderentrystatus.oestatusApproved) {
          // No domain and not approved
          let divr = new IcecontrolSettings("icedivider", { width: "75px" }, null, null);
          let actBtn = null;
          if (IceTypes.SourceType.srcTypeOfService == gl.src_type && defDomainType == IceTypes.ACCOUNT_TYPE.actPatient) {
            actBtn = new IcecontrolSettings("icepanelbutton", { text: "Import", class: [], glyphClass: "fa-plus" }, null, null, ImportContinue + gl.management_guideline_key);
          }
          else {
            actBtn = new IcecontrolSettings("icepanelbutton", { text: continueBtnText, class: [], glyphClass: "fa-plus" }, null, null, AddNewContinue + gl.management_guideline_key);
          }
          completingActionSection = new IcepanelsectionSettings(
            "CompleteActionSection", { class: [], styles: { width: "100%" } }, [], [
              divr,
              actBtn,
          ], null).setControlAlignment(SECTION_CONTROL_ALIGNMENT.ctrlAlignVertical);
        }
        else if (gl.trans_account.length > 0 && Iceutility.toLong(gl.order_status_type) == IceTypes.orderentrystatus.oestatusApproved) {
          // has domain and approved
          controls.push(new IcecontrolSettings("icelabel", { value: "Network Domain: " + gl.trans_account, width: "250px" }, null, null));
          if (defDomainType == IceTypes.ACCOUNT_TYPE.actPatient) {
            let divr = new IcecontrolSettings("icedivider", { width: "75px" }, null, null);
            let actBtn = null;
            let btns = [divr]
            if (IceTypes.SourceType.srcTypeOfService == gl.src_type && gl.src_key && gl.src_key.length > 0) {
              // Do nothing for now.
            }
            else if (IceTypes.SourceType.srcTypeOfService == gl.src_type) {
              actBtn = new IcecontrolSettings("icepanelbutton", { text: "Appointment", class: [], glyphClass: "fa-plus" }, null, null, AppointmentContinue + gl.management_guideline_key);
              btns.push(actBtn);
            }
            else {
              actBtn = new IcecontrolSettings("icepanelbutton", { text: "Request For Appointment", class: [], glyphClass: "fa-plus" }, null, null, NewRequestForAppointment + gl.management_guideline_key);
              btns.push(actBtn);
            }

            completingActionSection = new IcepanelsectionSettings(
              "CompleteActionSection", { class: [], styles: { width: "100%" } }, [], btns, null)
              .setControlAlignment(SECTION_CONTROL_ALIGNMENT.ctrlAlignVertical);
          }
          else if (defDomainType == IceTypes.ACCOUNT_TYPE.actSubscriber) {
            let divr = new IcecontrolSettings("icedivider", { width: "75px" }, null, null);
            let actBtn = null;
            let btns = [divr]
            if (IceTypes.SourceType.srcStatement == gl.src_type && gl.src_key && gl.src_key.length > 0) {
              // Do nothing for now.
            }
            else if (IceTypes.SourceType.srcStatement == gl.src_type) {
              actBtn = new IcecontrolSettings("icepanelbutton", { text: "Complete Billing", class: [], glyphClass: "fa-plus" }, null, null, BillingContinue + gl.management_guideline_key);
              btns.push(actBtn);
            }
            else {
              actBtn = new IcecontrolSettings("icepanelbutton", { text: "Request For Subscription to Benefits", class: [], glyphClass: "fa-plus" }, null, null, NewRequestForBenefits + gl.management_guideline_key);
              btns.push(actBtn);
            }

            completingActionSection = new IcepanelsectionSettings(
              "CompleteActionSection", { class: [], styles: { width: "100%" } }, [], btns, null)
              .setControlAlignment(SECTION_CONTROL_ALIGNMENT.ctrlAlignVertical);
          }
        }
      }

      controls.push(new IcecontrolSettings("icelabel", { value: "Reference #" + gl.management_guideline_key, width: "250px" }, null, null, "ReferenceNumber")
        .setControlName("ReferenceNumber"));

      let headerSection = new IcepanelsectionSettings("SurveyHeaderSection", { class: ["yalla"], styles: { width: "100%" } }, [], controls, null)
        .setControlAlignment(SECTION_CONTROL_ALIGNMENT.ctrlAlignHorizontal);
      surveySections.push(headerSection);
      if (completingActionSection) surveySections.push(completingActionSection);

    }
    catch (e) {
      console.log(e);
    }
    return surveySections;
  }

  private showAppointment(appt: appointment, gl: managementguideline, readonly: boolean): IcepanelsectionSettings[] {
    let appointmentSections: IcepanelsectionSettings[] = [];

    if (appt == null) return appointmentSections;

    try {
      let controls: IcecontrolSettings[] = [];
      let startdt = appt.time_slot_start; // To do fix this to convert to a Date()
      let proRefs: provider_reference[] = [];

      if (!Iceutility.isdefined(appt.appointment_key) || appt.appointment_key.length == 0) {
        appt.appointment_key = Iceutility.guid(true);
        appt.referral_from_key = Iceutility.guid(true);
        appt.patient_trans_account = gl.trans_account;
        gl.referral_from_key = appt.referral_from_key;

        if (!Iceutility.isdefined(appt.time_slot_start) || isNaN(appt.time_slot_start))
          startdt = Iceutility.GetLocalDate();

        appt.appointment_status = IceTypes.appt_status.apptstatComingUp;
        appt.appointment_status_note = "";
        appt.appointment_type = IceTypes.appt_type.appttypeInitial;
        appt.interval_type = IceTypes.interval.interval15;
        appt.offline_record_status = IceTypes.offlineRecStatus.offlineInsert;
        appt.slot_color = "#1400F7";
        appt.slot_font_color = "#F4EBEC";
        appt.subject = this.messageObj.subject;
      }

      if (appt.PROVS && appt.PROVS.length == 0) {
        let prosOb = gl.OBSERVS.filter(ob => ob.obx4_observation_subid == "organization_name"
          || ob.obx4_observation_subid == "last_name");
        for (let ipro = 0; ipro < prosOb.length; ipro++) {
          let pro = prosOb[ipro];
          if (pro == null) continue;

          try {
            let proVals = JSON.parse(pro.obx5_observation_value);
            if (proVals && Iceutility.isdefined(proVals.length) && proVals.length > 0) {
              let proDomainType = pro.obx4_observation_subid == "organization_name" ? IceTypes.ACCOUNT_TYPE.actFacility : IceTypes.ACCOUNT_TYPE.actProvider;
              let proDomain = proVals[0]["value"];
              let proRef = new provider_reference(null);
              proRef.provider_reference_key = Iceutility.guid(true);
              proRef.account_type = proDomainType;
              proRef.trans_account = proDomain;
              proRef.offline_record_status = IceTypes.offlineRecStatus.offlineInsert;
              proRefs.push(proRef);

              // Sync to appointment
              appt.PROVS.push(proRef);
            }
          }
          catch (e) {
            continue;
          }
        }
      }
      else {
        proRefs = appt.PROVS;
      }

      for (let iRef = 0; proRefs != null && iRef < proRefs.length; iRef++) {
        if (iRef == 0) { // Only show first calendar and use the others for availability

          if (readonly) {
            controls.push(new IcecontrolSettings("icelabel", { value: "Appointment Details:", width: "250px" }, null, null));
            controls.push(new IcecontrolSettings("icelabel", { value: "Date:", width: "100px" }, null, null, DateOfAppointment + gl.management_guideline_key)
              .setControlName(DateOfAppointment + gl.management_guideline_key)
              .createFormControl(Iceutility.getDateTextEx(Iceutility.ConvertFromDotNetServerTime(appt.time_slot_start), "-", true), []));

            controls.push(new IcecontrolSettings("icelabel", { value: "Telehealth Appointment: ", width: "50px", cursor: 'pointer' }, null, null, TelehealthAppointment + gl.management_guideline_key)
              .setControlName(TelehealthAppointment + gl.management_guideline_key)
              .createFormControl(appt.telehealth ? "Yes" : "No", []));
          }
          else {
            appt.trans_account = proRefs[iRef].trans_account;
            appt.account_type = proRefs[iRef].account_type;

            this.schService.getCalendar(proRefs[iRef].trans_account, proRefs[iRef].account_type, "", Iceutility.ConvertToUTC(startdt, false), "").subscribe(
              data => {
                if (data == null) return;
                let slotsToDisplay = [];

                for (let ical = 0; ical < data.length; ical++) {
                  let cal: calendar = data[ical];
                  if (cal.hasOwnProperty("DAYS")) {
                    let days: day[] = cal["DAYS"];
                    let start_slot = null, end_slot = null;

                    for (let iday = 0; iday < days.length; iday++) {
                      let day = days[iday];
                      if (day.hasOwnProperty("SLOTS")) {
                        let slots = day["SLOTS"];
                        for (let slotindex = 0; slotindex < slots.length; slotindex++) {
                          let slt: slot = slots[slotindex];
                          let appointments = slt["APPTS"];

                          if (Iceutility.isdefined(appointments) == false || appointments.length == 0) {
                            slotsToDisplay.push({ value: slt.header, name: slt.header });
                          }
                        }
                        break; // expect only one day
                      }
                    }
                  }
                }

                let theTime = Iceutility.getDateTextEx(startdt).split(" ")[1] + ((startdt.getHours() > 12) ? (' PM') : ' AM');
                let foundTime = slotsToDisplay.filter((t) => theTime == t.value);
                if (foundTime.length == 0) slotsToDisplay.push({ value: theTime, name: theTime });

                let frmGrp = null;
                let pnl = this.getAppointmentPanel(gl.management_guideline_key);
                if (pnl != null) frmGrp = pnl.getForm();
                controls.push(new IcecontrolSettings("icelabel", { value: "Appointment Details:", width: "250px" }, null, null));
                controls.push(new IcecontrolSettings("icedatepicker", { placeholder: "Date of Appointment", width: "100px" }, null, null, DateOfAppointment + gl.management_guideline_key)
                  .setControlName(DateOfAppointment + gl.management_guideline_key)
                  .createFormControl(startdt, [Validators.required])
                  .registerFormControl(DateOfAppointment + gl.management_guideline_key, frmGrp));

                controls.push(new IcecontrolSettings("iceselect", {
                  menuItems: slotsToDisplay,
                  width: "100px"
                }, null, null, TimeOfAppointment + gl.management_guideline_key, "Select Time")
                  .setControlName(TimeOfAppointment + gl.management_guideline_key)
                  .createFormControl(theTime, [Validators.required])
                  .registerFormControl(TimeOfAppointment + gl.management_guideline_key, frmGrp));

                controls.push(new IcecontrolSettings("iceslidetoggle", { placeholder: "Telehealth Appointment", width: "50px", cursor: 'pointer' }, null, null, TelehealthAppointment + gl.management_guideline_key)
                  .setControlName(TelehealthAppointment + gl.management_guideline_key)
                  .createFormControl(false, [Validators.required])
                  .registerFormControl(TelehealthAppointment + gl.management_guideline_key, frmGrp));

                controls.push(new IcecontrolSettings("iceinput", { width: "100%" }, null, null, TelehealthUrlForAppointment + gl.management_guideline_key, "Enter the meeting link here")
                  .setControlName(TelehealthUrlForAppointment + gl.management_guideline_key)
                  .createFormControl(appt.telehealth_url, null)
                  .registerFormControl(TelehealthUrlForAppointment + gl.management_guideline_key, frmGrp));
              },
              error => {
                console.log(JSON.stringify(this.schService.getLastErrors()));
              });
          }
        }
      }

      let headerSection = new IcepanelsectionSettings(AppointmentHeaderSection + gl.management_guideline_key, { class: ["yalla"], styles: { width: "100%" } }, [], controls, null)
        .setControlAlignment(SECTION_CONTROL_ALIGNMENT.ctrlAlignVertical);
      appointmentSections.push(headerSection);
    }
    catch (e) {
      console.log(e);
    }
    return appointmentSections;
  }

  private showBill(bill: superbillcharges, gl: managementguideline, readonly: boolean): IcepanelsectionSettings[] {
    let billSections: IcepanelsectionSettings[] = [];

    if (bill == null) return billSections;

    try {
      let controls: IcecontrolSettings[] = [];
      /*
      let startdt = appt.time_slot_start; // To do fix this to convert to a Date()
      let proRefs: provider_reference[] = [];

      if (!Iceutility.isdefined(appt.appointment_key) || appt.appointment_key.length == 0) {
        appt.appointment_key = Iceutility.guid(true);
        appt.referral_from_key = Iceutility.guid(true);
        appt.patient_trans_account = gl.trans_account;
        gl.referral_from_key = appt.referral_from_key;

        if (!Iceutility.isdefined(appt.time_slot_start) || isNaN(appt.time_slot_start))
          startdt = Iceutility.GetLocalDate();

        appt.appointment_status = IceTypes.appt_status.apptstatComingUp;
        appt.appointment_status_note = "";
        appt.appointment_type = IceTypes.appt_type.appttypeInitial;
        appt.interval_type = IceTypes.interval.interval15;
        appt.offline_record_status = IceTypes.offlineRecStatus.offlineInsert;
        appt.slot_color = "#1400F7";
        appt.slot_font_color = "#F4EBEC";
        appt.subject = this.messageObj.subject;
      }

      if (appt.PROVS && appt.PROVS.length == 0) {
        let prosOb = gl.OBSERVS.filter(ob => ob.obx4_observation_subid == "organization_name"
          || ob.obx4_observation_subid == "last_name");
        for (let ipro = 0; ipro < prosOb.length; ipro++) {
          let pro = prosOb[ipro];
          if (pro == null) continue;

          try {
            let proVals = JSON.parse(pro.obx5_observation_value);
            if (proVals && Iceutility.isdefined(proVals.length) && proVals.length > 0) {
              let proDomainType = pro.obx4_observation_subid == "organization_name" ? IceTypes.ACCOUNT_TYPE.actFacility : IceTypes.ACCOUNT_TYPE.actProvider;
              let proDomain = proVals[0]["value"];
              let proRef = new provider_reference(null);
              proRef.provider_reference_key = Iceutility.guid(true);
              proRef.account_type = proDomainType;
              proRef.trans_account = proDomain;
              proRef.offline_record_status = IceTypes.offlineRecStatus.offlineInsert;
              proRefs.push(proRef);

              // Sync to appointment
              appt.PROVS.push(proRef);
            }
          }
          catch (e) {
            continue;
          }
        }
      }
      else {
        proRefs = appt.PROVS;
      }

      for (let iRef = 0; proRefs != null && iRef < proRefs.length; iRef++) {
        if (iRef == 0) { // Only show first calendar and use the others for availability

          if (readonly) {
            controls.push(new IcecontrolSettings("icelabel", { value: "Appointment Details:", width: "250px" }, null, null));
            controls.push(new IcecontrolSettings("icelabel", { value: "Date:", width: "100px" }, null, null, DateOfAppointment + gl.management_guideline_key)
              .setControlName(DateOfAppointment + gl.management_guideline_key)
              .createFormControl(Iceutility.getDateTextEx(Iceutility.ConvertFromDotNetServerTime(appt.time_slot_start), "-", true), []));

            controls.push(new IcecontrolSettings("icelabel", { value: "Telehealth Appointment: ", width: "50px", cursor: 'pointer' }, null, null, TelehealthAppointment + gl.management_guideline_key)
              .setControlName(TelehealthAppointment + gl.management_guideline_key)
              .createFormControl(appt.telehealth ? "Yes" : "No", []));
          }
          else {
            appt.trans_account = proRefs[iRef].trans_account;
            appt.account_type = proRefs[iRef].account_type;

            this.schService.getCalendar(proRefs[iRef].trans_account, proRefs[iRef].account_type, "", Iceutility.ConvertToUTC(startdt, false), "").subscribe(
              data => {
                if (data == null) return;
                let slotsToDisplay = [];

                for (let ical = 0; ical < data.length; ical++) {
                  let cal: calendar = data[ical];
                  if (cal.hasOwnProperty("DAYS")) {
                    let days: day[] = cal["DAYS"];
                    let start_slot = null, end_slot = null;

                    for (let iday = 0; iday < days.length; iday++) {
                      let day = days[iday];
                      if (day.hasOwnProperty("SLOTS")) {
                        let slots = day["SLOTS"];
                        for (let slotindex = 0; slotindex < slots.length; slotindex++) {
                          let slt: slot = slots[slotindex];
                          let appointments = slt["APPTS"];

                          if (Iceutility.isdefined(appointments) == false || appointments.length == 0) {
                            slotsToDisplay.push({ value: slt.header, name: slt.header });
                          }
                        }
                        break; // expect only one day
                      }
                    }
                  }
                }

                let theTime = Iceutility.getDateTextEx(startdt).split(" ")[1] + ((startdt.getHours() > 12) ? (' PM') : ' AM');
                let foundTime = slotsToDisplay.filter((t) => theTime == t.value);
                if (foundTime.length == 0) slotsToDisplay.push({ value: theTime, name: theTime });

                let frmGrp = null;
                let pnl = this.getAppointmentPanel(gl.management_guideline_key);
                if (pnl != null) frmGrp = pnl.getForm();
                controls.push(new IcecontrolSettings("icelabel", { value: "Appointment Details:", width: "250px" }, null, null));
                controls.push(new IcecontrolSettings("icedatepicker", { placeholder: "Date of Appointment", width: "100px" }, null, null, DateOfAppointment + gl.management_guideline_key)
                  .setControlName(DateOfAppointment + gl.management_guideline_key)
                  .createFormControl(startdt, [Validators.required])
                  .registerFormControl(DateOfAppointment + gl.management_guideline_key, frmGrp));

                controls.push(new IcecontrolSettings("iceselect", {
                  menuItems: slotsToDisplay,
                  width: "100px"
                }, null, null, TimeOfAppointment + gl.management_guideline_key, "Select Time")
                  .setControlName(TimeOfAppointment + gl.management_guideline_key)
                  .createFormControl(theTime, [Validators.required])
                  .registerFormControl(TimeOfAppointment + gl.management_guideline_key, frmGrp));

                controls.push(new IcecontrolSettings("iceslidetoggle", { placeholder: "Telehealth Appointment", width: "50px", cursor: 'pointer' }, null, null, TelehealthAppointment + gl.management_guideline_key)
                  .setControlName(TelehealthAppointment + gl.management_guideline_key)
                  .createFormControl(false, [Validators.required])
                  .registerFormControl(TelehealthAppointment + gl.management_guideline_key, frmGrp));

                controls.push(new IcecontrolSettings("iceinput", { width: "100%" }, null, null, TelehealthUrlForAppointment + gl.management_guideline_key, "Enter the meeting link here")
                  .setControlName(TelehealthUrlForAppointment + gl.management_guideline_key)
                  .createFormControl(appt.telehealth_url, null)
                  .registerFormControl(TelehealthUrlForAppointment + gl.management_guideline_key, frmGrp));
              },
              error => {
                console.log(JSON.stringify(this.schService.getLastErrors()));
              });
          }
        }
      }
      */
      let headerSection = new IcepanelsectionSettings(BillingHeaderSection + gl.management_guideline_key, { class: ["yalla"], styles: { width: "100%" } }, [], controls, null)
        .setControlAlignment(SECTION_CONTROL_ALIGNMENT.ctrlAlignVertical);
      billSections.push(headerSection);
    }
    catch (e) {
      console.log(e);
    }
    return billSections;
  }

  getAppointmentPanel(key: string): IcepanelSettings {
    for (let irow = 0; irow < this.messageSettings.rows.length; irow++) {
      for (let ipnl = 0; ipnl < this.messageSettings.rows[irow].columns.length; ipnl++) {
        let pnl = this.messageSettings.rows[irow].columns[ipnl];
        if (pnl == null) continue;
        let secs = pnl.sections.filter(s => s.tag == AppointmentHeaderSection + key)
        if (secs.length > 0) {
          return pnl;
        }
      }
    }
    return null;
  }

  getBillingPanel(key: string): IcepanelSettings {
    for (let irow = 0; irow < this.messageSettings.rows.length; irow++) {
      for (let ipnl = 0; ipnl < this.messageSettings.rows[irow].columns.length; ipnl++) {
        let pnl = this.messageSettings.rows[irow].columns[ipnl];
        if (pnl == null) continue;
        let secs = pnl.sections.filter(s => s.tag == BillingHeaderSection + key)
        if (secs.length > 0) {
          return pnl;
        }
      }
    }
    return null;
  }

  getFirstPanel(): IcepanelSettings {
    for (let irow = 0; irow < this.messageSettings.rows.length; irow++) {
      for (let ipnl = 0; ipnl < this.messageSettings.rows[irow].columns.length; ipnl++) {
        let pnl: IcepanelSettings = this.messageSettings.rows[irow].columns[ipnl];
        if (pnl == null) continue;
        return pnl;
      }
    }
    return null;
  }

  isMessageSubjectRelatedTO(domainType: IceTypes.ACCOUNT_TYPE): boolean {
    let ret = false;
    if (this.messageObj.subject.length == 0) return ret;

    let parts = this.messageObj.subject.split(',');
    let topic = parts[parts.length - 1];
    switch (topic) {
      case IceTypes.RegistrationTopics.rtConsult:
      case IceTypes.RegistrationTopics.rtFollowup:
      case IceTypes.RegistrationTopics.rtSick:
      case IceTypes.RegistrationTopics.rtPregnant:
      case IceTypes.RegistrationTopics.rtCancer:
      case IceTypes.RegistrationTopics.rtDiabetic:
      case IceTypes.RegistrationTopics.rtHIV:
      case IceTypes.RegistrationTopics.rtCOVID19:
      case IceTypes.RegistrationTopics.rtMultiple: {
        ret = domainType == IceTypes.ACCOUNT_TYPE.actPatient;
        break;
      }
      case IceTypes.RegistrationTopics.rtPracticeDoctor:
      case IceTypes.RegistrationTopics.rtPracticeAdministrator:
      case IceTypes.RegistrationTopics.rtPracticeIT: {
        ret = domainType == IceTypes.ACCOUNT_TYPE.actProvider
          || domainType == IceTypes.ACCOUNT_TYPE.actFacility;
        break;
      }
      case IceTypes.RegistrationTopics.rtVendorHIE: {
        ret = domainType == IceTypes.ACCOUNT_TYPE.actVendor;
        break;
      }
      case IceTypes.RegistrationTopics.rtPharmacy: {
        ret = domainType == IceTypes.ACCOUNT_TYPE.actPharmacy;
        break;
      }
      case IceTypes.RegistrationTopics.rtPayer: {
        ret = domainType == IceTypes.ACCOUNT_TYPE.actPayer;
        break;
      }
      case IceTypes.RegistrationTopics.rtSubscriber: {
        ret = domainType == IceTypes.ACCOUNT_TYPE.actSubscriber;
        break;
      }
    }
    return ret;
  }

  viewSetup(msg: message): IcepanelcontainerSettings {
    let setup: IcepanelcontainerSettings = null;
    try {
      this.loading = false;

      if (msg == null) {
        return;
      }


      this.messageObj = msg;
      this.messageObj["_from"] = this.messageObj.from;
      this.messageObj["_to"] = this.messageObj.to;

      let firstGL: managementguideline = null;
      if (msg.GLRULES.length > 0)
        firstGL = msg.GLRULES[0];

      let countryObservation = null, dobObservationIndex = -1;

      if (firstGL != null) {
        countryObservation = msg.GLRULES[0].OBSERVS.filter(gl => gl.obx4_observation_subid === "country")
        dobObservationIndex = msg.GLRULES[0].OBSERVS.findIndex(gl => gl.obx4_observation_subid === "dob");
      }      

      if (!Iceutility.isdefined(countryObservation) || countryObservation.length === 0) {
        let countryOb = this.createobservation("Enter Country", "country", "");

        for (let iCountry = 0; iCountry < this.countries.length; iCountry++) {
          let country = this.countries[iCountry];
          countryOb.SUBTYPES.push(this.createsubtype(country.name, country.value, 0));
        }
        if (firstGL != null)
          firstGL.OBSERVS.splice(dobObservationIndex, 0, countryOb);
      }

      this.appSvc.addBreadcrumb(this.messageObj.subject, {}, true, "");

      let messageHeaderControls: IcecontrolSettings[] = [
      ];

      let surveyPanels = [];

      if (this.messageObj.trans_type == IceTypes.TRANSTYPE.itAlarm
        || this.messageObj.trans_type == IceTypes.TRANSTYPE.itSurvey) {
        debugger;
        let usrInfo = this.loginSvc.GetSessionUserInfo();        
        let demoAcs = this.loginSvc.getDemoAccess(usrInfo);
        this.showDemo = demoAcs != userTypes.USER_FEATURE_ACCESS.ufaNone;
        let to = this.messageObj.to.split(",");
        if (to.length > 0 && to[0].toLocaleLowerCase() == usrInfo.Username.toLocaleLowerCase()) {
          this.memberIsFirstRecipient = true;
          messageHeaderControls.push(new IcecontrolSettings("icelabel", { value: MessageService.getStatus(Iceutility.toLong(this.messageObj.message_status)), width: "250px" }, null, null, SurveyStatus)
            .setControlName(SurveyStatus));
        }
        else {
          let msgstatuses = [
            { value: IceTypes.trans_status.isDenied, name: MessageService.getStatus(IceTypes.trans_status.isDenied) },
            { value: IceTypes.trans_status.isPending, name: MessageService.getStatus(IceTypes.trans_status.isPending) },
            { value: IceTypes.trans_status.isReceived, name: MessageService.getStatus(IceTypes.trans_status.isReceived) },
            { value: IceTypes.trans_status.isReadyToSend, name: MessageService.getStatus(IceTypes.trans_status.isReadyToSend) },
            { value: IceTypes.trans_status.isVerified, name: MessageService.getStatus(IceTypes.trans_status.isVerified) },
          ];

          if (currentEnv == "dev" || currentEnv == "qa") {
            msgstatuses.push({ value: IceTypes.trans_status.isApproved, name: MessageService.getStatus(IceTypes.trans_status.isApproved) });
          }
          else {
            if (this.loginSvc.getHighestGroup(usrInfo, "*") > userTypes.USER_GROUPS.upGRT)
              msgstatuses.push({ value: IceTypes.trans_status.isApproved, name: MessageService.getStatus(IceTypes.trans_status.isApproved) });
          }

          messageHeaderControls.push(new IcecontrolSettings("iceselect", {
            menuItems: msgstatuses,
            width: "250px"
          }, null, null, MessageStatus, "Select Status")
            .setControlName(MessageStatus)
            .createFormControl(Iceutility.toLong(this.messageObj.message_status), [Validators.required]));
        }
      }

      messageHeaderControls.push(new IcecontrolSettings("iceh3", { value: "From: " + this.messageObj["_from"], width: "300px", hasFullWidthContainer: false }, null, null, "FromMember"));
      messageHeaderControls.push(new IcecontrolSettings("iceh3", { value: "To: " + this.messageObj["_to"], width: "300px", hasFullWidthContainer: false }, null, null, "ToMembers"));
      messageHeaderControls.push(new IcecontrolSettings("iceh3", { value: "Subject: " + this.messageObj.subject, width: "300px", hasFullWidthContainer: false }, null, null));

      debugger;
      let bodyControls: IcecontrolSettings[] = [
        new IcecontrolSettings("icediv", { value: this.messageObj.message_body, hasFullWidthContainer: false, renderAsHTML: true }, null, null)
      ];

      let messageSections: IcepanelsectionSettings[] = [
        new IcepanelsectionSettings("HeaderSection", { class: [""], styles: { width: "100%" } }, null, messageHeaderControls, null)
          .setControlAlignment(SECTION_CONTROL_ALIGNMENT.ctrlAlignVertical),
        new IcepanelsectionSettings("BodySection", { class: [""], styles: { width: "100%" } }, null, bodyControls, null)
          .setControlAlignment(SECTION_CONTROL_ALIGNMENT.ctrlAlignVertical)
      ];

      let panelTag = "MessageView";
      let panelKey = msg.message_key;

      let headerControls = [];

      if (this.messageObj.trans_type == IceTypes.TRANSTYPE.itInvite) {
        headerControls.push(new IcecontrolSettings("iceaction", { class: "fas fa-reply", width: "50px", tooltip: "Reply" }, null, null, ReplyMessage));
        headerControls.push(new IcecontrolSettings("iceaction", { class: "fas fa-reply-all", width: "50px", tooltip: "Reply All" }, null, null, ReplyAllMessage));
        headerControls.push(new IcecontrolSettings("iceaction", { class: "fas fa-forward", width: "50px", tooltip: "Forward" }, null, null, ForwardMessage));
        if (this.messageObj.offline_record_status == IceTypes.offlineRecStatus.offlineInsert
          || this.messageObj.offline_record_status == IceTypes.offlineRecStatus.offlineUpdate) {
          headerControls.push(new IcecontrolSettings("iceaction", { class: "fas fa-edit", width: "50px", tooltip: "Edit" }, null, null, EditMessage));
        }

        // if Apppointment then use fa calendar check otherwise user-check
        if (this.messageObj.GLRULES != null && this.messageObj.GLRULES.length > 0 && this.messageObj.GLRULES[0].src_type == IceTypes.SourceType.srcTypeOfService) {
          headerControls.push(new IcecontrolSettings("icesubmitbutton", { class: "fas fa-calendar-check", width: "50px", tooltip: "Accept" }, null, null, AcceptMessage));
          headerControls.push(new IcecontrolSettings("iceaction", { class: "fas fa-calendar-times", width: "50px", tooltip: "Decline" }, null, null, DeclineInvite));
          headerControls.push(new IcecontrolSettings("iceaction", { class: "fas fa-calendar-plus", width: "50px", tooltip: "Tentative" }, null, null, TentativeInvite));
          headerControls.push(new IcecontrolSettings("iceaction", { class: "fas fa-video alert-success", width: "50px", tooltip: "Join" }, null, null, JoinInvite));
          this.proService.getAppointment(this.messageObj.trans_account, this.messageObj.account_type, this.messageObj.GLRULES[0].src_key).subscribe(
            data => {
              if (data != null && data.length > 0) {
                let appt: appointment = <appointment>data[0];
                if (appt && this.schService.appointmentInSession(appt.time_slot_start, appt.time_slot_end, appt.appointment_status)) {
                  if (Iceutility.toBoolean(appt.telehealth)) {
                    if (this.appointmentsToManage == null)
                      this.appointmentsToManage = [];

                    this.appointmentsToManage.push(appt);
                  }
                }

                if (this.appointmentsToManage == null || this.appointmentsToManage.length == 0) {
                  let joinElem = document.getElementById(JoinInvite);
                  joinElem.style.display = "none";
                }
              }
            },
            error => {
              let joinElem = document.getElementById(JoinInvite);
              joinElem.style.display = "none";
              console.log(error);
            });
        }
        else {
          headerControls.push(new IcecontrolSettings("icesubmitbutton", { class: "fas fa-user-check", width: "50px", tooltip: "Accept" }, null, null, AcceptMessage));
        }
        /////////////////////////////////////////////////
        // Terms
        messageSections.push(this.showTermsSection(false));

        /////////////////////////////////////////////////
        // Not a Bot
        let notABotControls: IcecontrolSettings[] = [
          new IcecontrolSettings("icerecaptcha", { width: "50px" }, null, null, Recaptcha)
            .setControlName(Recaptcha)
            .createFormControl(false, [Validators.required])
        ];

        messageSections.push(new IcepanelsectionSettings("NotABotSection", { class: [""], styles: { width: "100%" } }, null, notABotControls, null)
          .setControlAlignment(SECTION_CONTROL_ALIGNMENT.ctrlAlignVertical)
        );

        this.loadDefaultTerms(false);
      }
      else if (this.messageObj.trans_type == IceTypes.TRANSTYPE.itAlarm
        || this.messageObj.trans_type == IceTypes.TRANSTYPE.itSurvey) {

        headerControls.push(new IcecontrolSettings("icesubmitbutton", { class: "fas fa-user-check", width: "50px", tooltip: "Submit Survey" }, null, null, SubmitSurvey));
        headerControls.push(new IcecontrolSettings("icecancelbutton", { class: "fas fa-times", width: "50px", tooltip: "Cancel" }, null, null, CancelMessage));

        let defDomainType = IceTypes.ACCOUNT_TYPE.actNone;
        let conBtn = "CONTINUE";        
        if (this.messageObj.GLRULES.length == 0) {
          if (this.isMessageSubjectRelatedTO(IceTypes.ACCOUNT_TYPE.actPatient)) {
            defDomainType = IceTypes.ACCOUNT_TYPE.actPatient; 
            let gl = new managementguideline();
            gl.order_status_type = IceTypes.orderentrystatus.oestatusWaiting;
            gl.title = "Patient Portal Setup Request";
            gl.description = this.messageObj.message_body;
            gl.management_guideline_key = Iceutility.guid(true);

            gl.OBSERVS.push(this.createobservation("", "divider1", "", IceTypes.RESULT_STATUS.rsFinal));
            gl.OBSERVS.push(this.createobservation("Patient's Information", "label1", "", IceTypes.RESULT_STATUS.rsFinal));
            gl.OBSERVS.push(this.createobservation("Enter Patient's First Name", "first_name", ""));
            gl.OBSERVS.push(this.createobservation("Enter Last Name", "last_name", ""));
            gl.OBSERVS.push(this.createobservation("Enter Middle Initial", "initial", "", IceTypes.RESULT_STATUS.rsNotObserved));
            gl.OBSERVS.push(this.createobservation("Enter Additional Name", "additional_name", "", IceTypes.RESULT_STATUS.rsNotObserved));
            let countryOb = this.createobservation("Enter Country", "country", "");

            for (let iCountry = 0; iCountry < this.countries.length; iCountry++) {
              let country = this.countries[iCountry];
              countryOb.SUBTYPES.push(this.createsubtype(country.name, country.value, 0));
            }
            gl.OBSERVS.push(countryOb);

            gl.OBSERVS.push(this.createobservation("Enter Date of Birth" + " " + this.dateFormat !== "" ? this.dateFormat : Iceutility.getCurrentDateFormat(), "dob", ""));
            let genderOb = this.createobservation("Enter Gender", "sex", "");
            genderOb.SUBTYPES.push(this.createsubtype("N/A", "U", 0));
            genderOb.SUBTYPES.push(this.createsubtype("Male", "M", 0));
            genderOb.SUBTYPES.push(this.createsubtype("Female", "F", 0));
            gl.OBSERVS.push(genderOb);
            gl.OBSERVS.push(this.createobservation("Enter Federal or State ID", "identification_code", ""));
            gl.OBSERVS.push(this.createobservation("Phone No.", "phone", ""));
            gl.OBSERVS.push(this.createobservation("Address Line 1", "street1", ""));
            gl.OBSERVS.push(this.createobservation("Address Line 2", "street2", "", IceTypes.RESULT_STATUS.rsNotObserved));
            gl.OBSERVS.push(this.createobservation("City", "city", ""));
            gl.OBSERVS.push(this.createobservation("State or Province", "state_id", ""));
            gl.OBSERVS.push(this.createobservation("Postal Code", "postal_code", "", IceTypes.RESULT_STATUS.rsNotObserved));
            gl.OBSERVS.push(this.createobservation("Patient's Chief Complaint or Symptom 1", "chief_complaint1", "", IceTypes.RESULT_STATUS.rsNotObserved));
            gl.OBSERVS.push(this.createobservation("Patient's Chief Complaint or Symptom 2", "chief_complaint2", "", IceTypes.RESULT_STATUS.rsNotObserved));
            gl.OBSERVS.push(this.createobservation("Patient's Chief Complaint or Symptom 3", "chief_complaint3", "", IceTypes.RESULT_STATUS.rsNotObserved));

            this.messageObj.GLRULES.push(gl);
            conBtn = "Create Patient Portal";
          }
          else if (this.isMessageSubjectRelatedTO(IceTypes.ACCOUNT_TYPE.actSubscriber)) {
            defDomainType = IceTypes.ACCOUNT_TYPE.actSubscriber;
            let gl = new managementguideline();
            gl.order_status_type = IceTypes.orderentrystatus.oestatusWaiting;
            gl.title = "Subscriber Membership Application"; // To do Voter Registration
            let voteReg = false, nominate = false;
            if (this.messageObj.subject.toLowerCase().indexOf("vote") >= 0
              || this.messageObj.subject.toLowerCase().indexOf("ballot") >= 0) {
              gl.title = "Membership Voter Registration";
              voteReg = true;
            }
            else if (this.messageObj.subject.toLowerCase().indexOf("nominate") >= 0) {
              gl.title = "Nomination Application Form";
              nominate = true;
            }
            gl.description = this.messageObj.message_body;
            gl.management_guideline_key = Iceutility.guid(true);

            let domCap = !voteReg ? "Subscriber's" : "Member's";
            gl.OBSERVS.push(this.createobservation("", "divider1", "", IceTypes.RESULT_STATUS.rsFinal));
            gl.OBSERVS.push(this.createobservation(domCap + " Information", "label1", "", IceTypes.RESULT_STATUS.rsFinal));
            gl.OBSERVS.push(this.createobservation("Enter " + domCap + " First Name", "first_name", ""));
            gl.OBSERVS.push(this.createobservation("Enter Last Name", "last_name", ""));
            gl.OBSERVS.push(this.createobservation("Enter Middle Initial", "initial", "", IceTypes.RESULT_STATUS.rsNotObserved));
            gl.OBSERVS.push(this.createobservation("Enter Additional Name (e.g. LionHeart)", "additional_name", "", IceTypes.RESULT_STATUS.rsNotObserved));
            let countryOb = this.createobservation("Enter Country", "country", "");

            for (let iCountry = 0; iCountry < this.countries.length; iCountry++) {
              let country = this.countries[iCountry];
              countryOb.SUBTYPES.push(this.createsubtype(country.name, country.value, 0));
            }
            gl.OBSERVS.push(countryOb);
            if (!voteReg) gl.OBSERVS.push(this.createobservation("Enter Date of Birth" + " " + this.dateFormat !== "" ? this.dateFormat : Iceutility.getCurrentDateFormat(), "dob", ""));
            let genderOb = this.createobservation("Enter Gender", "sex", "");
            if (!voteReg) genderOb.SUBTYPES.push(this.createsubtype("N/A", "U", 0));

            genderOb.SUBTYPES.push(this.createsubtype("Male", "M", 0));
            genderOb.SUBTYPES.push(this.createsubtype("Female", "F", 0));
            gl.OBSERVS.push(genderOb);
            if (!voteReg) gl.OBSERVS.push(this.createobservation("Enter Federal or State ID", "identification_code", ""));
            gl.OBSERVS.push(this.createobservation("Phone No.", "phone", ""));
            gl.OBSERVS.push(this.createobservation("Address Line 1", "street1", ""));
            gl.OBSERVS.push(this.createobservation("Address Line 2", "street2", "", IceTypes.RESULT_STATUS.rsNotObserved));
            gl.OBSERVS.push(this.createobservation("City", "city", ""));
            gl.OBSERVS.push(this.createobservation("State or Province", "state_id", ""));
            gl.OBSERVS.push(this.createobservation("Postal Code", "postal_code", "", IceTypes.RESULT_STATUS.rsNotObserved));
            gl.OBSERVS.push(this.createobservation(domCap + " Local (Optional)", "primary_local", "", IceTypes.RESULT_STATUS.rsNotObserved));

            this.messageObj.GLRULES.push(gl);
            conBtn = "Create Subscriber Portal";
            if (voteReg)
              conBtn = "Download Ballot";
            else if(nominate)
              conBtn = "Next Nomination";
          }
          else if (this.isMessageSubjectRelatedTO(IceTypes.ACCOUNT_TYPE.actProvider)) {
            defDomainType = IceTypes.ACCOUNT_TYPE.actProvider; 
            let gl = new managementguideline();
            gl.order_status_type = IceTypes.orderentrystatus.oestatusWaiting;
            gl.title = "Practice Setup Request";
            gl.description = this.messageObj.message_body;
            gl.management_guideline_key = Iceutility.guid(true);

            let providerTyoeOb = this.createobservation("Are you registering as an Individual doctor or Organization?", "account_type", "");
            providerTyoeOb.SUBTYPES.push(this.createsubtype("Individual doctor", IceTypes.ACCOUNT_TYPE.actProvider.toString(), 0));
            providerTyoeOb.SUBTYPES.push(this.createsubtype("Organization, Facility or department", IceTypes.ACCOUNT_TYPE.actFacility.toString(), 0));
            gl.OBSERVS.push(providerTyoeOb);

            gl.OBSERVS.push(this.createobservation("Name of your organization", "organization_name", ""));
            gl.OBSERVS.push(this.createobservation("Enter Your First Name", "first_name", ""));
            gl.OBSERVS.push(this.createobservation("Enter Last Name", "last_name", ""));
            gl.OBSERVS.push(this.createobservation("Enter Middle Initial", "initial", "", IceTypes.RESULT_STATUS.rsNotObserved));
            gl.OBSERVS.push(this.createobservation("Enter Additional Name", "additional_name", "", IceTypes.RESULT_STATUS.rsNotObserved));
            gl.OBSERVS.push(this.createobservation("Enter Date of Birth" + " " + this.dateFormat !== "" ? this.dateFormat : Iceutility.getCurrentDateFormat(), "dob", ""));
            let countryOb = this.createobservation("Enter Country", "country", "");

            for (let iCountry = 0; iCountry < this.countries.length; iCountry++) {
              let country = this.countries[iCountry];
              countryOb.SUBTYPES.push(this.createsubtype(country.name, country.value, 0));
            }
            gl.OBSERVS.push(countryOb);
            let genderOb = this.createobservation("Enter Gender", "sex", "");
            genderOb.SUBTYPES.push(this.createsubtype("N/A", "U", 0));
            genderOb.SUBTYPES.push(this.createsubtype("Male", "M", 0));
            genderOb.SUBTYPES.push(this.createsubtype("Female", "F", 0));
            gl.OBSERVS.push(genderOb);
            gl.OBSERVS.push(this.createobservation("Enter Your Medical License", "identification_code", ""));
            gl.OBSERVS.push(this.createobservation("Phone No.", "phone", ""));
            gl.OBSERVS.push(this.createobservation("Address Line 1", "street1", ""));
            gl.OBSERVS.push(this.createobservation("Address Line 2", "street2", "", IceTypes.RESULT_STATUS.rsNotObserved));
            gl.OBSERVS.push(this.createobservation("City", "city", ""));
            gl.OBSERVS.push(this.createobservation("State or Province", "state_id", ""));
            gl.OBSERVS.push(this.createobservation("Postal Code", "postal_code", "", IceTypes.RESULT_STATUS.rsNotObserved));

            this.messageObj.GLRULES.push(gl);
            conBtn = "Create Practice";
          }
          else if (this.isMessageSubjectRelatedTO(IceTypes.ACCOUNT_TYPE.actVendor)
            || this.isMessageSubjectRelatedTO(IceTypes.ACCOUNT_TYPE.actPharmacy)
            || this.isMessageSubjectRelatedTO(IceTypes.ACCOUNT_TYPE.actPayer)) {

            if (this.isMessageSubjectRelatedTO(IceTypes.ACCOUNT_TYPE.actVendor))
              defDomainType = IceTypes.ACCOUNT_TYPE.actVendor;
            else if (this.isMessageSubjectRelatedTO(IceTypes.ACCOUNT_TYPE.actPharmacy))
              defDomainType = IceTypes.ACCOUNT_TYPE.actPharmacy;
            else if (this.isMessageSubjectRelatedTO(IceTypes.ACCOUNT_TYPE.actPayer))
              defDomainType = IceTypes.ACCOUNT_TYPE.actPayer;

            if (defDomainType != IceTypes.ACCOUNT_TYPE.actNone) {
              let gl = new managementguideline();
              gl.order_status_type = IceTypes.orderentrystatus.oestatusWaiting;

              if (defDomainType == IceTypes.ACCOUNT_TYPE.actVendor)
                gl.title = "Vendor Setup Request";
              else if (defDomainType == IceTypes.ACCOUNT_TYPE.actPharmacy)
                gl.title = "Pharmacy Setup Request";
              else if (defDomainType == IceTypes.ACCOUNT_TYPE.actPayer)
                gl.title = "Payer Setup Request";

              gl.description = this.messageObj.message_body;
              gl.management_guideline_key = Iceutility.guid(true);

              gl.OBSERVS.push(this.createobservation("Name of your organization", "organization_name", ""));
              gl.OBSERVS.push(this.createobservation("Enter Your First Name", "first_name", ""));
              gl.OBSERVS.push(this.createobservation("Enter Last Name", "last_name", ""));
              gl.OBSERVS.push(this.createobservation("Enter Middle Initial", "initial", "", IceTypes.RESULT_STATUS.rsNotObserved));
              gl.OBSERVS.push(this.createobservation("Enter Additional Name", "additional_name", "", IceTypes.RESULT_STATUS.rsNotObserved));
              gl.OBSERVS.push(this.createobservation("Enter Date of Birth" + " " + this.dateFormat !== "" ? this.dateFormat : Iceutility.getCurrentDateFormat(), "dob", ""));
              let countryOb = this.createobservation("Enter Country", "country", "");

              for (let iCountry = 0; iCountry < this.countries.length; iCountry++) {
                let country = this.countries[iCountry];
                countryOb.SUBTYPES.push(this.createsubtype(country.name, country.value, 0));
              }
              gl.OBSERVS.push(countryOb);
              let genderOb = this.createobservation("Enter Gender", "sex", "");
              genderOb.SUBTYPES.push(this.createsubtype("N/A", "U", 0));
              genderOb.SUBTYPES.push(this.createsubtype("Male", "M", 0));
              genderOb.SUBTYPES.push(this.createsubtype("Female", "F", 0));
              gl.OBSERVS.push(genderOb);
              gl.OBSERVS.push(this.createobservation("Phone No.", "phone", ""));
              gl.OBSERVS.push(this.createobservation("Address Line 1", "street1", ""));
              gl.OBSERVS.push(this.createobservation("Address Line 2", "street2", "", IceTypes.RESULT_STATUS.rsNotObserved));
              gl.OBSERVS.push(this.createobservation("City", "city", ""));
              gl.OBSERVS.push(this.createobservation("State or Province", "state_id", ""));
              gl.OBSERVS.push(this.createobservation("Postal Code", "postal_code", "", IceTypes.RESULT_STATUS.rsNotObserved));

              this.messageObj.GLRULES.push(gl);
              if (defDomainType == IceTypes.ACCOUNT_TYPE.actVendor)
                conBtn = "Create Vendor";
              else if (defDomainType == IceTypes.ACCOUNT_TYPE.actPharmacy)
                conBtn = "Create Pharmacy";
              else if (defDomainType == IceTypes.ACCOUNT_TYPE.actPayer)
                conBtn = "Create Payer";
            }
          }
        }

        if (defDomainType == IceTypes.ACCOUNT_TYPE.actNone) {
          defDomainType = this.isMessageSubjectRelatedTO(IceTypes.ACCOUNT_TYPE.actPatient) ? IceTypes.ACCOUNT_TYPE.actPatient : IceTypes.ACCOUNT_TYPE.actProvider;
        }

        let oneGLisWaiting: boolean = false;
        let surveyPanel = null;
        let surveysections: IcepanelsectionSettings[] = [];
        this.messageObj.GLRULES.forEach((gl) => {
          if (Iceutility.toLong(gl.order_status_type) == IceTypes.orderentrystatus.oestatusTransactionError) {
            headerControls.push(new IcecontrolSettings("icebutton", { class: "fas fa-times-circle", width: "50px", tooltip: "Reset" }, null, null, ResetMessage));
          }

          if (Iceutility.toLong(gl.order_status_type) == IceTypes.orderentrystatus.oestatusWaiting) {
            oneGLisWaiting = true;
          }

          surveysections = surveysections.concat(this.showSureveyHeading(gl, defDomainType, conBtn));
          // To do update provider and facility options
          surveysections = surveysections.concat(this.showSureveySections(gl.OBSERVS, gl.order_status_type));

          if (Iceutility.toLong(gl.order_status_type) == IceTypes.orderentrystatus.oestatusApproved
            && gl.trans_account && gl.trans_account.length > 0 && gl.src_type == IceTypes.SourceType.srcTypeOfService) {

            let appt: appointment = null;
            if (gl.src_key && gl.src_key.length > 0) {
              let prosOb = gl.OBSERVS.filter(ob => ob.obx4_observation_subid == "organization_name"
                || ob.obx4_observation_subid == "last_name");
              for (let iproOb = 0; iproOb < prosOb.length; iproOb++) {
                let proOb = prosOb[iproOb];
                if (proOb == null) continue;

                try {
                  let proVals = JSON.parse(proOb.obx5_observation_value);
                  if (proVals && Iceutility.isdefined(proVals.length) && proVals.length > 0) {
                    // to do accommodate for pharmacy
                    let proDomainType = proOb.obx4_observation_subid == "organization_name" ? IceTypes.ACCOUNT_TYPE.actFacility : IceTypes.ACCOUNT_TYPE.actProvider;
                    let proDomain = proVals[0]["value"];

                    this.proService.getAppointment(proDomain, proDomainType, gl.src_key).subscribe(
                      data => {
                        if (data != null && data.length > 0) {
                          appt = data[0]
                          let appSections = this.showAppointment(appt, gl, true);
                          if (appSections == null) return;

                          if (surveyPanel != null && surveyPanel.sections) surveyPanel.sections = surveyPanel.sections.concat(appSections);
                        }
                      },
                      error => {
                        console.log(error);
                      });
                  }
                }
                catch (e) {
                  continue;
                }

                break; // one pro is good enough to pull the appointment
              }            
            }
            else {
              appt = new appointment();
              if (this.appointmentsToManage == null) {
                this.appointmentsToManage = []
                this.appointmentsToManage.push(appt);
              }

              surveysections = surveysections.concat(this.showAppointment(appt, gl, false));
            }
          }
          else if (Iceutility.toLong(gl.order_status_type) == IceTypes.orderentrystatus.oestatusApproved
            && gl.trans_account && gl.trans_account.length > 0 && gl.src_type == IceTypes.SourceType.srcStatement) {
            // check defDomainType == actSubscriber
            let bill: superbillcharges = null;
            if (gl.src_key && gl.src_key.length > 0) {
              this.acctService.getBill(gl.requester_trans_account, gl.requester_account_type, gl.src_key).subscribe(
                data => {
                  if (data != null && data.length > 0) {
                    bill = data[0];
                    let billSections = this.showBill(data[0], gl, true);
                    if (billSections == null) return;

                    if (surveyPanel != null && surveyPanel.sections) surveyPanel.sections = surveyPanel.sections.concat(billSections);
                  }
                },
                error => {
                  console.log(error);
                });
            }
            else {
              bill = new superbillcharges();
              if (this.billsToManage == null) {
                this.billsToManage = []
                this.billsToManage.push(bill);
              }

              surveysections = surveysections.concat(this.showBill(bill, gl, false));
            }
          }


          // Load Survey
          surveyPanel = new IceexpansionpanelSettings("GLSurvey" + gl.management_guideline_key, gl.management_guideline_key, gl.title, "", surveysections, null, null, null, 0)
            .enableForm();
          surveyPanels.push(surveyPanel);
        });

        /////////////////////////////////////////////////
        // Terms
        if (this.messageObj.CONSENTS.length > 0) {
          surveysections.push(this.showAcceptedTermsSection());
          this.consentAcceptedDataSource.data = this.messageObj.CONSENTS;
        }

        if (this.messageObj.ATTACHMENTS.length > 0) {
          surveysections.push(this.showAttachments());
          this.attachmentsDataSource.data = this.messageObj.ATTACHMENTS;
        }

        if (oneGLisWaiting) {
          // Default Terms
          this.loadDefaultTerms(true);
          surveysections.push(this.showTermsSection(!this.memberIsFirstRecipient));

          /////////////////////////////////////////////////
          // Attachments
          surveysections.push(this.showDropZone());
          surveysections.push(this.showAttachments());
          this.attachmentsDataSource.data = this.messageObj.ATTACHMENTS;
        }
      }
      else {
        headerControls.push(new IcecontrolSettings("iceaction", { class: "fas fa-reply", width: "50px", tooltip: "Reply" }, null, null, ReplyMessage));
        headerControls.push(new IcecontrolSettings("iceaction", { class: "fas fa-reply-all", width: "50px", tooltip: "Reply All" }, null, null, ReplyAllMessage));
        headerControls.push(new IcecontrolSettings("iceaction", { class: "fas fa-forward", width: "50px", tooltip: "Forward" }, null, null, ForwardMessage));
        if (this.messageObj.offline_record_status == IceTypes.offlineRecStatus.offlineInsert
          || this.messageObj.offline_record_status == IceTypes.offlineRecStatus.offlineUpdate) {
          headerControls.push(new IcecontrolSettings("iceaction", { class: "fas fa-edit", width: "50px", tooltip: "Edit" }, null, null, EditMessage));
        }
        headerControls.push(new IcecontrolSettings("icecancelbutton", { class: "fas fa-times", width: "50px", tooltip: "Cancel" }, null, null, CancelMessage));

        /////////////////////////////////////////////////
        // Attachments
        messageSections.push(this.showAttachments());
        this.attachmentsDataSource.data = this.messageObj.ATTACHMENTS;

        /////////////////////////////////////////////////
        // Progress spinner
        this.loaderSection = new IcepanelsectionSettings("LoaderSection", { class: [""], styles: { width: "100%" } }, [], [], []);
        messageSections.push(this.loaderSection);
      }

      let panels: IcepanelSettings[] = [
        new IcepanelSettings(panelTag, panelKey, this.messageObj.trans_type == IceTypes.TRANSTYPE.itInvite ? "Accept Invitation" : "View Message", "", messageSections, headerControls)
          .enableForm()
      ];

      if (surveyPanels.length > 0) panels = panels.concat(surveyPanels);

      let panelrows: IcepanelcontainerRowSettings[] = [new IcepanelcontainerRowSettings(panels)];
      setup = new IcepanelcontainerSettings("MessageViewContainer", panelrows);
    }
    catch (e) {
      console.log(e);
    }
    return setup;
  }

  ngOnInit() {
    this.appSvc.refreshMenus();

    this.medCodeService.getCodes("COUNTRY", "", "", "").
      subscribe(data => {
        if (data && data.length > 0 && data[0] != null) {
          let ditCodes = [];

          this.countries = data.map(c => {
            if (c.DITXML != null && c.DITXML.length > 0) ditCodes.push(c);
            return { value: c.code, name: c.title + " (" + c.code + ")" }
          });
        }
      });
  }

  private submitInvite(acptConsents: consentreference[], invtCmd: string) {
    let finalDest = this.messageObj.GLRULES.length > 0 ? "dashboard" : "members";
    if (AcceptMessage == invtCmd) {
      this.messageService.acceptInvite(this.messageObj).subscribe(data => {
        // To do is error then stay on view
        this.router.navigate([this.navSvc.buildRoute(finalDest, false)]);
      }, error => {
        console.log(error);
      });
    }
    else if (DeclineInvite == invtCmd) {
      this.messageService.declineInvite(this.messageObj).subscribe(data => {
        // To do is error then stay on view
        this.router.navigate([this.navSvc.buildRoute(finalDest, false)]);
      }, error => {
        console.log(error);
      });
    }
    else if (TentativeInvite == invtCmd) {
      this.messageService.tentativeInvite(this.messageObj).subscribe(data => {
        // To do is error then stay on view
        this.router.navigate([this.navSvc.buildRoute(finalDest, false)]);
      }, error => {
        console.log(error);
      });
    }

  }

  public onHeaderActionClick(event) {
    if (event.headerCtrl && event.headerCtrl.id == CancelMessage) {
      this.router.navigate([this.navSvc.buildRoute("messages/sent", false)]);
      return;
    }

    if (this.messageObj.trans_type == IceTypes.TRANSTYPE.itInvite
      && (event.type == "submit" ||
      (event.headerCtrl && (DeclineInvite == event.headerCtrl.id || TentativeInvite == event.headerCtrl.id || JoinInvite == event.headerCtrl.id)))) {
      let inviteCmd = AcceptMessage;
      if (DeclineInvite == event.headerCtrl.id)
        inviteCmd = DeclineInvite;
      else if (TentativeInvite == event.headerCtrl.id)
        inviteCmd = TentativeInvite;

      // Terms validation
      var acceptedCons: consentreference[] = [];
      if (this.defaultConsents != null) {
        for (let ia = 0; ia < this.consentDataSource.data.length; ia++) {
          let agreedCons: ConsentListObject = this.consentDataSource.data[ia];
          if (agreedCons.agree === false) {
            this.messageService.logMessage(IceTypes.LOGTYPE.ltError, "You must accept the terms of use to continue.");
            return;
          }
          let defCons: consentreference = null;

          let foundDefCons = this.defaultConsents.filter(c => {
            return c.consent_reference_key == agreedCons.key
          });

          if (foundDefCons.length > 0) {
            defCons = foundDefCons[0];
            defCons.login_user_name = agreedCons.login_user_name;
            defCons.full_name = agreedCons.full_name;
            defCons.date_of_consent = Iceutility.ConvertToUTC(Iceutility.GetLocalDate(), true);
            defCons.note_status_type = IceTypes.notestatus.statusComplete;
            acceptedCons.push(defCons);
          }
        }
      }

      for (let accI = 0; accI < acceptedCons.length; accI++) {
        let acc = acceptedCons[accI];
        let found = this.messageObj.CONSENTS.filter(c => c.code == acc.code && c.login_user_name == acc.login_user_name);
        if (found.length == 0) {
          this.messageObj.CONSENTS.push(acc);
        }
      }

      if (event.headerCtrl.id == JoinInvite && this.appointmentsToManage != null) {
        for (let iapt = 0; iapt < this.appointmentsToManage.length; iapt++) {
          let appt: appointment = this.appointmentsToManage[iapt];
          if (appt == null) continue;

          if (this.schService.appointmentInSession(appt.time_slot_start, appt.time_slot_end, appt.appointment_status))
            this.schService.navigateToTelehealth(appt.telehealth_url);
        }
      }

      if (location.hostname.toLowerCase().indexOf('localhost') >= 0) {
        this.submitInvite(acceptedCons, inviteCmd);
        return;
      }

      this.googleService.verifyRecaptcha(this.googleService.recaptchaToken).subscribe(data => {
        this.submitInvite(acceptedCons, inviteCmd);
      }, error => {
        console.log(error);
        this.showErrorMessage("An error during Captcha verification.");
      });
      return;
    }
    else if ((this.messageObj.trans_type == IceTypes.TRANSTYPE.itAlarm
      || this.messageObj.trans_type == IceTypes.TRANSTYPE.itSurvey)
      && (event.type == "submit" || event.type == "click")) {

      if (event.headerCtrl && event.headerCtrl.id == ResetMessage) {
        let posToReset = this.messageObj.GLRULES.map((gl) => { return Iceutility.toLong(gl.order_status_type); }).indexOf(IceTypes.orderentrystatus.oestatusTransactionError);
        if (posToReset >= 0) this.messageObj.GLRULES.splice(posToReset, 1);

        this.messageService.updateMessage(this.messageObj, this.navSvc).subscribe(
          data => {
            if (Iceutility.isdefined(data) && data.length > 0) {
              this.router.navigate([this.navSvc.buildRoute("dashboard", false)]);
            }
          },
          error => {
            console.log(error);
            this.showErrorMessage();
          });
        return;
      }

      let mainFormGrp = this.messageSettings.rows[0].columns[0].getForm();
      if (mainFormGrp == null || mainFormGrp.valid == false) {
        this.messageService.logMessage(IceTypes.LOGTYPE.ltError, "You must complete all required fields.");
        return;
      }

      this.messageObj.message_status = mainFormGrp.get(MessageStatus) != null ? mainFormGrp.get(MessageStatus).value : this.messageObj.message_status;
      for (let iGLIndex = 0; iGLIndex < this.messageObj.GLRULES.length; iGLIndex++) {
        let gl = this.messageObj.GLRULES[iGLIndex];
        if (gl == null) continue;

        let panels = this.messageSettings.rows[0].columns.filter((pnl) => pnl.panelKey == gl.management_guideline_key);
        if (panels.length == 0) continue;

        let formGrp = panels[0].getForm();
        if (formGrp == null || (formGrp.valid == false && this.memberIsFirstRecipient)) {
          this.messageService.logMessage(IceTypes.LOGTYPE.ltError, "You must complete all required fields.");
          return;
        }

        if (this.memberIsFirstRecipient
          && (gl.order_status_type == IceTypes.orderentrystatus.oestatusWaiting
          || gl.order_status_type == IceTypes.orderentrystatus.oestatusTransactionError)) {
          gl.order_status_type = IceTypes.orderentrystatus.oestatusRendered;
          gl.order_status_note = "Survey update submitted"; // This is the customer member
          gl.order_entry_date = Iceutility.ConvertToUTC(Iceutility.GetLocalDate(), true);
        }
        else {
          gl.order_status_type = formGrp.get(SurveyStatus) != null && formGrp.get(SurveyStatus).value ? formGrp.get(SurveyStatus).value : gl.order_status_type;
        }

        if (formGrp.get(StatusDescription) != null) {
          gl.order_status_note = formGrp.get(StatusDescription).value;          
          gl.order_entry_date = Iceutility.ConvertToUTC(Iceutility.GetLocalDate(), true);
        }

        if (!Iceutility.isStringUndefinedNullOrEmpty(gl.order_status_note)) {
          let alt = new alert();
          alt.alert_key = Iceutility.guid(false);
          alt.alert_type = IceTypes.ALERTTYPE.alertNotification;
          alt.account_type = this.messageObj.account_type;
          alt.trans_account = this.messageObj.trans_account;
          alt.alert_date = Iceutility.ConvertToUTC(Iceutility.GetLocalDate(), true);
          alt.management_guideline_key = gl.management_guideline_key;
          alt.title = "RE: " + gl.title;
          alt.description = gl.order_status_note;

          gl.ALERTS.push(alt);
        }

        if (this.memberIsFirstRecipient) {
          // Terms validation
          let acceptedCons: consentreference[] = [];
          for (let ia = 0; ia < this.consentDataSource.data.length; ia++) {
            if (this.consentDataSource.data[ia].agree == false) {
              this.messageService.logMessage(IceTypes.LOGTYPE.ltError, "You must accept the terms of use to continue.");
              return;
            }
            let agreedCons: ConsentListObject = this.consentDataSource.data[ia];
            let defCons: consentreference = null;

            let foundCons = this.messageObj.CONSENTS.filter(c => {
              return c.consent_reference_key == agreedCons.key
            });

            if (foundCons.length > 0) {
              // already exist
              continue;
            }

            let foundDefCons = this.defaultConsents.filter(c => {
              return c.consent_reference_key == agreedCons.key
            });

            if (foundDefCons.length > 0) {
              defCons = foundDefCons[0];
              defCons.login_user_name = this.messageObj.from;
              defCons.full_name = agreedCons.full_name;
              defCons.date_of_consent = Iceutility.ConvertToUTC(Iceutility.GetLocalDate(), true);
              defCons.note_status_type = IceTypes.notestatus.statusComplete;
              acceptedCons.push(defCons);
            }
          }

          this.messageObj.CONSENTS = this.messageObj.CONSENTS.concat(acceptedCons);

          for (let icon = 0; icon < this.messageObj.CONSENTS.length; icon++) {
            if (Iceutility.isTextDateTime(this.messageObj.CONSENTS[icon].date_of_consent))
              this.messageObj.CONSENTS[icon].date_of_consent = Iceutility.convertToUTCEx(this.messageObj.CONSENTS[icon].date_of_consent);
          }
        }

        // find observ based on control name
        let parts = this.messageObj.subject.split(',');
        if (parts.length > 0) {
          let topic = parts[parts.length - 1];
          switch (topic) {
            case IceTypes.RegistrationTopics.rtConsult:
            case IceTypes.RegistrationTopics.rtFollowup:
            case IceTypes.RegistrationTopics.rtSick:
            case IceTypes.RegistrationTopics.rtPregnant:
            case IceTypes.RegistrationTopics.rtCancer:
            case IceTypes.RegistrationTopics.rtDiabetic:
            case IceTypes.RegistrationTopics.rtHIV:
            case IceTypes.RegistrationTopics.rtCOVID19:
            case IceTypes.RegistrationTopics.rtMultiple: {

              gl.OBSERVS.forEach((ob) => {
                if (formGrp.get(ob.obx4_observation_subid) != null && formGrp.get(ob.obx4_observation_subid).value != null) {
                  // In this case non-null value mean that the control was initialized and null means the value is
                  // either a label or the control was not initialized
                  switch (ob.obx4_observation_subid) {
                    case "dob": {
                      // to do validate the date
                      ob.obx5_observation_value = formGrp.get(ob.obx4_observation_subid).value;
                      break;
                    }
                    default: {
                      if (ob.obx2_value_type == "iceautocomplete") {
                        let valCtrl = formGrp.get(ob.obx4_observation_subid);
                        try {
                          let selected = JSON.parse(valCtrl.value);
                          if (selected != null) { // just checking to see if object
                            ob.obx5_observation_value = valCtrl.value;
                          }
                        }
                        catch (ob_e) {
                          let elem = <HTMLInputElement>document.getElementById(ob.obx4_observation_subid + ob.observation_key);
                          if (elem && elem.value.length > 0) {
                            ob.obx5_observation_value = JSON.stringify([{ name: elem.value, value: "" }]);
                          }
                          console.log(ob_e);
                        }
                      }
                      else {
                        ob.obx5_observation_value = formGrp.get(ob.obx4_observation_subid).value;
                      }
                      break;
                    }
                  }
                }

                if (this.patientToAdd != null && this.patientToAdd.ENTS.length > 0) {
                  let ent = this.patientToAdd.ENTS[0];
                  let con = null;
                  let ids = null;
                  switch (ob.obx4_observation_subid) {
                    case "first_name": { ent.first_name = ob.obx5_observation_value; break; }
                    case "last_name": { ent.last_name = ob.obx5_observation_value; break; }
                    case "initial": { ent.initial = ob.obx5_observation_value; break; }
                    case "additional_name": { ent.additional_name = ob.obx5_observation_value; break; }
                    case "sex": { ent.sex = ob.obx5_observation_value; break; }
                    case "dob": { ent.dob = Iceutility.convertToUTCEx(ob.obx5_observation_value); break; }
                    case "phone": {
                      con = new contact();
                      con.contact_key = Iceutility.guid(true);
                      con.communication_number = ob.obx5_observation_value;
                      con.communication_number_qualifier = "TE";
                      this.patientToAdd.CONS.push(con);
                      break;
                    }
                    case "identification_code": {
                      ids = new identification();
                      ids.identification_key = Iceutility.guid(true);
                      ids.identification_code = ob.obx5_observation_value;
                      ids.identification_code_qualifier = "SE";
                      this.patientToAdd.IDS.push(ids);
                      break;
                    }
                    case "street1":
                    case "street2":
                    case "city":
                    case "state_id":
                    case "postal_code":
                    {
                      let adr: address = null;
                      if (this.patientToAdd.ADS.length == 0) {
                        adr = new address();
                        this.patientToAdd.ADS.push(adr);
                      }
                      else {
                        adr = this.patientToAdd.ADS[0];
                      }

                      switch (ob.obx4_observation_subid) {
                        case "street1": { adr.street1 = ob.obx5_observation_value; break; }
                        case "street2": { adr.street2 = ob.obx5_observation_value; break; }
                        case "city": { adr.city = ob.obx5_observation_value; break; }
                        case "state_id": { adr.state_id = ob.obx5_observation_value; break; }
                        case "postal_code": { adr.postal_code = ob.obx5_observation_value; break; }                            
                      }                      
                      break;
                    }
                  }
                }
              });

              if (iGLIndex == 0 && this.patientToAdd != null) {
                this.ptService.insertPatient("", IceTypes.ACCOUNT_TYPE.actNone, this.patientToAdd, this.messageObj.to.split(',')[0]).subscribe(
                  ptdata => {
                    if (Iceutility.isdefined(ptdata) && ptdata.length > 0) {
                      let pt = <patient>ptdata[0]
                      // Associate patient
                      gl.trans_account = pt.trans_account;
                    }
                    this.patientToAdd = null;
                    if (iGLIndex >= this.messageObj.GLRULES.length - 1) { // we are looping so only once do we update
                      this.messageService.updateMessage(this.messageObj, this.navSvc).subscribe(
                        data => {
                          this.router.navigate([this.navSvc.buildRoute("domain/" + IceTypes.ACCOUNT_TYPE.actPatient.toString(), false)]);
                        },
                        error => {
                          console.log(error);
                          this.showErrorMessage();
                        });
                    }
                  },
                  error => {
                    this.patientToAdd = null;
                    console.log(error);
                    this.showErrorMessage();
                  });
              }
              else {
                if (iGLIndex >= this.messageObj.GLRULES.length - 1) { // we are looping so only once do we update
                  // To do: clear up the subtypes for providers and facilities selection
                  this.messageService.updateMessage(this.messageObj, this.navSvc).subscribe(
                    data => {
                      if (Iceutility.isdefined(data) && data.length > 0) {
                        this.router.navigate([this.navSvc.buildRoute("dashboard", false)]);
                      }
                    }, error => {
                      console.log(error);
                      this.showErrorMessage();
                    });
                }
              }

              break;
            }
            case IceTypes.RegistrationTopics.rtPracticeDoctor:
            case IceTypes.RegistrationTopics.rtPracticeAdministrator:
            case IceTypes.RegistrationTopics.rtPracticeIT: {
              let practiceAccountType: IceTypes.ACCOUNT_TYPE = IceTypes.ACCOUNT_TYPE.actNone;

              gl.OBSERVS.forEach((ob) => {
                if (formGrp.get(ob.obx4_observation_subid) != null && formGrp.get(ob.obx4_observation_subid).value != null) {
                  // In this case non-null value mean that the control was initialized and null means the value is
                  // either a label or the control was not initialized
                  switch (ob.obx4_observation_subid) {
                    case "dob": {
                      // to do validate the date
                      ob.obx5_observation_value = formGrp.get(ob.obx4_observation_subid).value;
                      break;
                    }
                    default: {
                      ob.obx5_observation_value = formGrp.get(ob.obx4_observation_subid).value;
                      if (ob.obx4_observation_subid == "account_type") {
                        practiceAccountType = <IceTypes.ACCOUNT_TYPE>Iceutility.toLong(ob.obx5_observation_value);
                      }
                      break;
                    }
                  }
                }

                if (this.providerToAdd != null && this.providerToAdd.ENTS.length > 0) {
                  let ent = this.providerToAdd.ENTS[0];
                  let con = null;
                  let ids = null;
                  switch (ob.obx4_observation_subid) {
                    case "organization_name": { ent.organization_name = ob.obx5_observation_value; break; }
                    case "first_name": { ent.first_name = ob.obx5_observation_value; break; }
                    case "last_name": { ent.last_name = ob.obx5_observation_value; break; }
                    case "initial": { ent.initial = ob.obx5_observation_value; break; }
                    case "additional_name": { ent.additional_name = ob.obx5_observation_value; break; }
                    case "sex": { ent.sex = ob.obx5_observation_value; break; }
                    case "dob": { ent.dob = Iceutility.convertToUTCEx(ob.obx5_observation_value); break; }
                    case "phone": {
                      con = new contact();
                      con.contact_key = Iceutility.guid(true);
                      con.communication_number = ob.obx5_observation_value;
                      con.communication_number_qualifier = "TE";
                      this.providerToAdd.CONS.push(con);
                      break;
                    }
                    case "identification_code": {
                      ids = new identification();
                      ids.identification_key = Iceutility.guid(true);
                      ids.identification_code = ob.obx5_observation_value;
                      ids.identification_code_qualifier = "SE";
                      this.providerToAdd.IDS.push(ids);
                      break;
                    }
                    case "street1":
                    case "street2":
                    case "city":
                    case "state_id":
                    case "postal_code":
                      {
                        let adr: address = null;
                        if (this.providerToAdd.ADS.length == 0) {
                          adr = new address();
                          this.providerToAdd.ADS.push(adr);
                        }
                        else {
                          adr = this.providerToAdd.ADS[0];
                        }

                        switch (ob.obx4_observation_subid) {
                          case "street1": { adr.street1 = ob.obx5_observation_value; break; }
                          case "street2": { adr.street2 = ob.obx5_observation_value; break; }
                          case "city": { adr.city = ob.obx5_observation_value; break; }
                          case "state_id": { adr.state_id = ob.obx5_observation_value; break; }
                          case "postal_code": { adr.postal_code = ob.obx5_observation_value; break; }
                        }
                        break;
                      }
                  }
                }
              });

              if (practiceAccountType == IceTypes.ACCOUNT_TYPE.actNone) {
                let doms = gl.OBSERVS.filter((ob) => ob.obx4_observation_subid == "account_type");
                if (doms.length > 0) {
                  practiceAccountType = <IceTypes.ACCOUNT_TYPE>Iceutility.toLong(doms[0].obx5_observation_value);
                }
                if (practiceAccountType == IceTypes.ACCOUNT_TYPE.actNone) {
                  this.proService.logMessage(IceTypes.LOGTYPE.ltUserAlert, "Type of practice not selected.");
                  return;
                }
              }

              if (iGLIndex == 0 && this.providerToAdd != null) {
                if (practiceAccountType == IceTypes.ACCOUNT_TYPE.actFacility)
                  this.providerToAdd.tablename = "FACILITY";

                this.proService.insertProvider(practiceAccountType, this.providerToAdd, this.messageObj.to.split(',')[0]).subscribe(
                  prodata => {
                    if (Iceutility.isdefined(prodata) && prodata.length > 0) {
                      let prov = <provider>prodata[0]
                      // Associate patient
                      gl.trans_account = prov.trans_account;
                    }
                    this.providerToAdd = null;
                    if (iGLIndex >= this.messageObj.GLRULES.length - 1) { // we are looping so only once do we update
                      this.messageService.updateMessage(this.messageObj, this.navSvc).subscribe(
                        data => {
                          this.router.navigate([this.navSvc.buildRoute("dashboard", false)]);
                        },
                        error => {
                          console.log(error);
                          this.showErrorMessage();
                        });
                    }
                  },
                  error => {
                    this.providerToAdd = null;
                    this.showErrorMessage();
                  });
              }
              else {
                if (iGLIndex >= this.messageObj.GLRULES.length - 1) { // we are looping so only once do we update
                  this.messageService.updateMessage(this.messageObj, this.navSvc).subscribe(data => {
                    if (Iceutility.isdefined(data) && data.length > 0) {
                      this.router.navigate([this.navSvc.buildRoute("dashboard", false)]);
                    }
                  }, error => {
                    console.log(error);
                    this.showErrorMessage();
                  });
                }
              }
              break;
            }
            case IceTypes.RegistrationTopics.rtVendorHIE:
            case IceTypes.RegistrationTopics.rtPharmacy:
            case IceTypes.RegistrationTopics.rtPayer:
            case IceTypes.RegistrationTopics.rtSubscriber: {
              gl.OBSERVS.forEach((ob) => {
                if (formGrp.get(ob.obx4_observation_subid) != null && formGrp.get(ob.obx4_observation_subid).value != null) {
                  // In this case non-null value mean that the control was initialized and null means the value is
                  // either a label or the control was not initialized
                  switch (ob.obx4_observation_subid) {
                    case "dob": {
                      // to do validate the date
                      ob.obx5_observation_value = formGrp.get(ob.obx4_observation_subid).value;
                      break;
                    }
                    default: {
                      ob.obx5_observation_value = formGrp.get(ob.obx4_observation_subid).value;
                      break;
                    }
                  }
                }

                let domToAdd = this.domainToAdd[topic];
                if (domToAdd != null && domToAdd.ENTS.length > 0) {
                  let ent = domToAdd.ENTS[0];
                  let con = null;
                  let ids = null;
                  switch (ob.obx4_observation_subid) {
                    case "organization_name": { ent.organization_name = ob.obx5_observation_value; break; }
                    case "first_name": { ent.first_name = ob.obx5_observation_value; break; }
                    case "last_name": { ent.last_name = ob.obx5_observation_value; break; }
                    case "initial": { ent.initial = ob.obx5_observation_value; break; }
                    case "additional_name": { ent.additional_name = ob.obx5_observation_value; break; }
                    case "sex": { ent.sex = ob.obx5_observation_value; break; }
                    case "dob": { ent.dob = Iceutility.convertToUTCEx(ob.obx5_observation_value); break; }
                    case "phone": {
                      con = new contact();
                      con.contact_key = Iceutility.guid(true);
                      con.communication_number = ob.obx5_observation_value;
                      con.communication_number_qualifier = "TE";
                      domToAdd.CONS.push(con);
                      break;
                    }
                    case "identification_code": {
                      ids = new identification();
                      ids.identification_key = Iceutility.guid(true);
                      ids.identification_code = ob.obx5_observation_value;
                      ids.identification_code_qualifier = "SE";
                      domToAdd.IDS.push(ids);
                      break;
                    }
                    case "street1":
                    case "street2":
                    case "city":
                    case "state_id":
                    case "postal_code":
                      {
                        let adr: address = null;
                        if (domToAdd.ADS.length == 0) {
                          adr = new address();
                          domToAdd.ADS.push(adr);
                        }
                        else {
                          adr = domToAdd.ADS[0];
                        }

                        switch (ob.obx4_observation_subid) {
                          case "street1": { adr.street1 = ob.obx5_observation_value; break; }
                          case "street2": { adr.street2 = ob.obx5_observation_value; break; }
                          case "city": { adr.city = ob.obx5_observation_value; break; }
                          case "state_id": { adr.state_id = ob.obx5_observation_value; break; }
                          case "postal_code": { adr.postal_code = ob.obx5_observation_value; break; }
                        }
                        break;
                      }
                  }
                }
              });

              let submitDom = this.domainToAdd[topic]
              if (iGLIndex == 0 && submitDom != null && IceTypes.RegistrationTopics.rtVendorHIE == topic) {
                this.venService.insertVendor(submitDom, this.messageObj.to.split(',')[0]).subscribe(
                  vendata => {
                    if (Iceutility.isdefined(vendata) && vendata.length > 0) {
                      let ven = <vendor>vendata[0]
                      // Associate vendor
                      gl.trans_account = ven.trans_account;
                    }
                    this.domainToAdd[IceTypes.RegistrationTopics.rtVendorHIE] = null;
                    if (iGLIndex >= this.messageObj.GLRULES.length - 1) { // we are looping so only once do we update
                      this.messageService.updateMessage(this.messageObj, this.navSvc).subscribe(
                        data => {
                          this.router.navigate([this.navSvc.buildRoute("dashboard", false)]);
                        },
                        error => {
                          console.log(error);
                          this.showErrorMessage();
                        });
                    }
                  },
                  error => {
                    this.domainToAdd[IceTypes.RegistrationTopics.rtVendorHIE] = null;
                    console.log(error);
                    this.showErrorMessage();
                  });
              }
              else if (iGLIndex == 0 && submitDom != null && IceTypes.RegistrationTopics.rtPharmacy == topic) {
                this.pharmService.insertPharmacy(submitDom, this.messageObj.to.split(',')[0]).subscribe(
                  pharmdata => {
                    if (Iceutility.isdefined(pharmdata) && pharmdata.length > 0) {
                      let pharm = <pharmacy>pharmdata[0]
                      // Associate pharmacy
                      gl.trans_account = pharm.trans_account;
                    }
                    this.domainToAdd[IceTypes.RegistrationTopics.rtPharmacy] = null;
                    if (iGLIndex >= this.messageObj.GLRULES.length - 1) { // we are looping so only once do we update
                      this.messageService.updateMessage(this.messageObj, this.navSvc).subscribe(
                        data => {
                          this.router.navigate([this.navSvc.buildRoute("dashboard", false)]);
                        },
                        error => {
                          console.log(error);
                          this.showErrorMessage();
                        });
                    }
                  },
                  error => {
                    this.domainToAdd[IceTypes.RegistrationTopics.rtPharmacy] = null;
                    console.log(error);
                    this.showErrorMessage();
                  });
              }
              else if (iGLIndex == 0 && submitDom != null && IceTypes.RegistrationTopics.rtPayer == topic) {
                this.payerService.insertPayer(submitDom, this.messageObj.to.split(',')[0]).subscribe(
                  payerdata => {
                    if (Iceutility.isdefined(payerdata) && payerdata.length > 0) {
                      let payr = <payer>payerdata[0]
                      // Associate payer
                      gl.trans_account = payr.trans_account;
                    }
                    this.domainToAdd[IceTypes.RegistrationTopics.rtPayer] = null;
                    if (iGLIndex >= this.messageObj.GLRULES.length - 1) { // we are looping so only once do we update
                      this.messageService.updateMessage(this.messageObj, this.navSvc).subscribe(
                        data => {
                          this.router.navigate([this.navSvc.buildRoute("dashboard", false)]);
                        },
                        error => {
                          console.log(error);
                          this.showErrorMessage();
                        });
                    }
                  },
                  error => {
                    this.domainToAdd[IceTypes.RegistrationTopics.rtPayer] = null;
                    console.log(error);
                    this.showErrorMessage();
                  });
              }
              else if (iGLIndex == 0 && submitDom != null && IceTypes.RegistrationTopics.rtSubscriber == topic) {
                debugger;
                if (this.messageObj.subject.toLowerCase().indexOf("vote") >= 0
                  || this.messageObj.subject.toLowerCase().indexOf("ballot") >= 0) {
                  this.domainToAdd[IceTypes.RegistrationTopics.rtSubscriber] = null;

                  let newgl = new managementguideline();

                  newgl.order_status_type = IceTypes.orderentrystatus.oestatusWaiting;
                  newgl.management_guideline_key = Iceutility.guid(true);
                  newgl.title = "2022 Election Ballot";
                  newgl.description = "Instructions for completing your vote.";
                  newgl.src_type = IceTypes.SourceType.srcClinicalResults;

                  newgl.OBSERVS.push(this.createobservation("Enter Your Vote for :", "label1", "", IceTypes.RESULT_STATUS.rsFinal));

                  //let pyrOb = this.createobservation("Name of Payer or Organization", "organization_name", "", IceTypes.RESULT_STATUS.rsNotObserved, "iceautocomplete");
                  //gl.OBSERVS.push(pyrOb);

                  let insertCandidate = (prompt, fld, name1, namevalue1, name2?: string, namevalue2?: string, name3?: string, namevalue3?: string) => {
                    let candidateOb = this.createobservation(prompt, fld, "");
                    candidateOb.SUBTYPES.push(this.createsubtype("No Vote", "NV", 0));
                    candidateOb.SUBTYPES.push(this.createsubtype(name1, namevalue1, 0));
                    if (name2) candidateOb.SUBTYPES.push(this.createsubtype(name2, namevalue2, 0));
                    if (name3) candidateOb.SUBTYPES.push(this.createsubtype(name3, namevalue3, 0));
                    newgl.OBSERVS.push(candidateOb);
                  };

                  insertCandidate("President", "president", "A.W. ProphetElijah (Incumbent)", "A.W. ProphetElijah");
                  insertCandidate("1st. Vice President", "vice1president", "Decton Mitchell (Incumbent, aka. Lionside)", "Decton Mitchell");
                  insertCandidate("2nd. Vice President", "vice2president", "Michael Robinson (Incumbent, aka. Jah Mike)", "Michael Robinson");
                  insertCandidate("Treasurer", "treasurer", "Alvin Ridgle (Incumbent, aka. Kush)", "Alvin Ridgle");
                  insertCandidate("Financial Secretary", "financialsecretary", "Piccolo Lewis (Incumbent)", "Piccolo Lewis", "Donte Turner (aka. Iadon)", "Donte Turner");
                  insertCandidate("Recording Corresponding Secretary", "rcsecretary", "Biniyam Lefe", "Biniyam Lefe");
                  insertCandidate("Chaplain", "chaplain", "Dante Evans", "Dante Evans");
                  insertCandidate("Sergeant at Arms", "sergeantatarms", "Reginald Swain", "Reginald Swain");
                  insertCandidate("1st. Elected Member", "firstelected", "Dr.Tishay Salary-Mitchell", "Dr. Tishay Salary-Mitchell");
                  insertCandidate("2nd. Elected Member", "secondelected", "Derek Black", "Derek Black");
                  insertCandidate("3rd. Elected Member", "thirdelected", "Ronald Spence", "Ronald Spence");

                  this.messageObj.GLRULES.push(newgl);

                  //if (this.messageSettings.rows[0].columns.length == 0)
                  //  this.messageSettings.rows[0].columns = [];

                  //let surveysections: IcepanelsectionSettings[] = [];
                  //surveysections = surveysections.concat(this.showSureveyHeading(gl, IceTypes.ACCOUNT_TYPE.actSubscriber));
                  //surveysections = surveysections.concat(this.showSureveySections(gl.OBSERVS, gl.order_status_type));

                  //this.messageSettings.rows[0].columns.push(new IceexpansionpanelSettings("GLSurvey" + gl.management_guideline_key, gl.management_guideline_key, gl.title, "", surveysections, null, null, null, 0)
                  //  .enableForm());

                  //setTimeout(() => {
                  //  document.getElementById(SurveyStatus + gl.management_guideline_key).scrollIntoView();
                  //}, 500);

                  this.messageService.updateMessage(this.messageObj, this.navSvc).subscribe(
                    data => {
                      this.router.navigate([this.navSvc.buildRoute("dashboard", false)]);
                    },
                    error => {
                      console.log(error);
                      this.showErrorMessage();
                    });
                }
                else if (this.messageObj.subject.toLowerCase().indexOf("nominate") >= 0) {
                  // Next Nomination
                  debugger;
                }
                else {
                  this.ptService.insertSubscriber("", IceTypes.ACCOUNT_TYPE.actNone, submitDom, this.messageObj.to.split(',')[0]).subscribe(
                    subdata => {
                      if (Iceutility.isdefined(subdata) && subdata.length > 0) {
                        let sub = <subscriber>subdata[0];
                        // Associate payer
                        gl.trans_account = sub.subscriber_key;
                      }
                      this.domainToAdd[IceTypes.RegistrationTopics.rtSubscriber] = null;
                      if (iGLIndex >= this.messageObj.GLRULES.length - 1) { // we are looping so only once do we update
                        this.messageService.updateMessage(this.messageObj, this.navSvc).subscribe(
                          data => {
                            this.router.navigate([this.navSvc.buildRoute("dashboard", false)]);
                          },
                          error => {
                            console.log(error);
                            this.showErrorMessage();
                          });
                      }
                    },
                    error => {
                      this.domainToAdd[IceTypes.RegistrationTopics.rtSubscriber] = null;
                      console.log(error);
                      this.showErrorMessage();
                    });
                }
              }
              else {
                if (iGLIndex >= this.messageObj.GLRULES.length - 1) { // we are looping so only once do we update
                  this.messageService.updateMessage(this.messageObj, this.navSvc).subscribe(data => {
                    if (Iceutility.isdefined(data) && data.length > 0) {
                      this.router.navigate([this.navSvc.buildRoute("dashboard", false)]);
                    }
                  }, error => {
                    console.log(error);
                    this.showErrorMessage();
                  });
                }
              }
              break;
            }
            default: {
              this.messageService.updateMessage(this.messageObj, this.navSvc).subscribe(data => {
                if (Iceutility.isdefined(data) && data.length > 0) {
                  this.router.navigate([this.navSvc.buildRoute("dashboard", false)]);
                }
              }, error => {
                console.log(error);
                this.showErrorMessage();
              });
              break;
            }
          }
        }

       
      }

      return;
    }

    if (event.headerCtrl == null) return;

    let memid = "";
    let userInfo = this.loginSvc.GetSessionUserInfo();
    if (userInfo) {
      memid = userInfo.Username;
    }

    if (this.messageObj.trans_account != null && this.messageObj.trans_account.length > 0) {
      let highestGrp = this.loginSvc.getHighestGroup(userInfo, this.messageObj.trans_account);
      if (highestGrp != userTypes.USER_GROUPS.upUNK) {
        // To do open domain
        if (this.messageObj.account_type == IceTypes.ACCOUNT_TYPE.actPatient) {
          this.appSvc.openPatient(this.messageObj.trans_account, true);
        }
        else {
          this.appSvc.openAccount(this.messageObj.trans_account, this.messageObj.account_type);
        }
      }
      else {      
        this.messageService.logMessage(IceTypes.LOGTYPE.ltError, "You do not have permission to view clinical information within this message.");
      }
    }

    switch (event.headerCtrl.id) {
      case ForwardMessage: {
        let msg = this.messageObj;
        msg.parent_message_key = this.messageObj.message_key;
        msg.from = memid;
        msg.message_key = "";
        msg.to = "";
        msg.cc = "";
        msg.subject = this.messageObj.subject.toLowerCase().indexOf("re:") > 0 ? this.messageObj.subject : "RE: " + this.messageObj.subject;
        msg.offline_record_status = IceTypes.offlineRecStatus.offlineInsert;
        msg.trans_account = this.messageObj.trans_account;
        msg.account_type = this.messageObj.account_type;

        // To do add GLRULES to msg
        this.messageService.addMessage(msg, this.navSvc).subscribe(data => {
          if (Iceutility.isdefined(data) && data.length > 0) {
            this.router.navigate([this.navSvc.buildRoute("forwardmessage/" + data[0].message_key, false)]);
          }
        }, error => {
          console.log(error);
        });
        break;
      }
      case ReplyMessage:
      case ReplyAllMessage: {
        let msg: message = new message();
        msg.parent_message_key = this.messageObj.message_key;
        msg.from = memid;
        msg.message_key = "";
        if (event.headerCtrl.id === ReplyAllMessage) {
          msg.to = this.messageObj.to;
          msg.to += (msg.to.length == 0 ? this.messageObj.from : ", " + this.messageObj.from);
          msg.cc = this.messageObj.cc;
        } else if (event.headerCtrl.id === ReplyMessage) {
          msg.to = this.messageObj.from;
        }
        msg.subject = this.messageObj.subject.toLowerCase().indexOf("re:") > 0 ? this.messageObj.subject : "RE: " + this.messageObj.subject;
        msg.offline_record_status = IceTypes.offlineRecStatus.offlineInsert;
        msg.trans_account = this.messageObj.trans_account;
        msg.account_type = this.messageObj.account_type;

        // To do add GLRULES to msg

        this.messageService.addMessage(msg, this.navSvc).subscribe(data => {
          if (Iceutility.isdefined(data) && data.length > 0) {
            this.router.navigate([this.navSvc.buildRoute("replymessage/" + data[0].message_key, false)]);
          }
        }, error => {
          console.log(error);
        });

        break;
      }
      case EditMessage: {
        this.router.navigate([this.navSvc.buildRoute("newmessage/" + this.messageObj.message_key, false)]);
        break;
      }
    }

  }

  onMatGridColClick(event) {
    if (event.rowData == null) {
      this.messageService.logMessage(IceTypes.LOGTYPE.ltError, "Invalid data. Can not download the file");
      window.scrollTo(0, 0);
      return;
    }

    let panel = this.getFirstPanel();

    if (Iceutility.isdefined(panel) && panel.loading) {
      return;
    }

    this.showHideProgressSpinner();

    if (event.matTableSettings != null && event.matTableSettings.tag == "AttachmentsTable") {
      this.messageService.loadMessageFile(this.messageObj.message_key, event.rowData.external_data_key, IceTypes.SourceType.srcMiscellaneousForms, event.rowData.title, this.onFileDownload.bind(this));
    }
    else if (event.matTableSettings != null && (event.matTableSettings.tag == "AcceptConsentTable" || event.matTableSettings.tag == "ConsentTable")) {
      this.domainSvc.loadConsentFile(event.rowData.login_user_name,
        Iceutility.isdefined(event.rowData.consent_reference_key) && event.rowData.consent_reference_key.length > 0 ? event.rowData.consent_reference_key : event.rowData.key, event.rowData.external_data_key, IceTypes.SourceType.srcMiscellaneousForms, this.onFileDownload.bind(this));
    }
  }

  public onButtonClick(event) {
    if (event.buttonSettings == null) return;

    try {
      if (event.buttonSettings.id != null && event.buttonSettings.id.indexOf(AddNewContinue) >= 0) {
        // Disable button

        if (this.isMessageSubjectRelatedTO(IceTypes.ACCOUNT_TYPE.actPatient)) {
          if (this.patientToAdd == null) {
            this.patientToAdd = new patient();
            this.patientToAdd.entity_key = Iceutility.guid(true);
            this.patientToAdd.offline_record_status = IceTypes.offlineRecStatus.offlineInsert;
            let ent = new entity();
            ent.entity_key = this.patientToAdd.entity_key;
            ent.offline_record_status = IceTypes.offlineRecStatus.offlineInsert;
            this.patientToAdd.ENTS.push(ent);

            let ads = new address();
            ads.address_key = this.patientToAdd.address_key = Iceutility.guid(true);
            ads.offline_record_status = IceTypes.offlineRecStatus.offlineInsert;
            this.patientToAdd.ADS.push(ads);
          }
        }
        else if (this.isMessageSubjectRelatedTO(IceTypes.ACCOUNT_TYPE.actSubscriber)) {
          if (this.domainToAdd[IceTypes.RegistrationTopics.rtSubscriber] == null) {
            let domToAdd = this.domainToAdd[IceTypes.RegistrationTopics.rtSubscriber] = new subscriber();
            domToAdd.entity_key = Iceutility.guid(true);
            domToAdd.offline_record_status = IceTypes.offlineRecStatus.offlineInsert;
            let ent = new entity();
            ent.entity_key = domToAdd.entity_key;
            ent.offline_record_status = IceTypes.offlineRecStatus.offlineInsert;
            domToAdd.ENTS.push(ent);

            let ads = new address();
            ads.address_key = domToAdd.address_key = Iceutility.guid(true);
            ads.offline_record_status = IceTypes.offlineRecStatus.offlineInsert;
            domToAdd.ADS.push(ads);
          }
        }
        else if (this.isMessageSubjectRelatedTO(IceTypes.ACCOUNT_TYPE.actProvider)) {
          if (this.providerToAdd == null) {
            this.providerToAdd = new provider("PROVIDER");
            this.providerToAdd.entity_key = Iceutility.guid(true);
            this.providerToAdd.offline_record_status = IceTypes.offlineRecStatus.offlineInsert;
            let ent = new entity();
            ent.entity_key = this.providerToAdd.entity_key;
            ent.offline_record_status = IceTypes.offlineRecStatus.offlineInsert;
            this.providerToAdd.ENTS.push(ent);

            let ads = new address();
            ads.address_key = this.providerToAdd.address_key = Iceutility.guid(true);
            ads.offline_record_status = IceTypes.offlineRecStatus.offlineInsert;
            this.providerToAdd.ADS.push(ads);
          }
        }
        else if (this.isMessageSubjectRelatedTO(IceTypes.ACCOUNT_TYPE.actVendor)
          || this.isMessageSubjectRelatedTO(IceTypes.ACCOUNT_TYPE.actPharmacy)
          || this.isMessageSubjectRelatedTO(IceTypes.ACCOUNT_TYPE.actPayer)) {
          debugger;
          let regType = "";
          if (this.isMessageSubjectRelatedTO(IceTypes.ACCOUNT_TYPE.actVendor))
            regType = IceTypes.RegistrationTopics.rtVendorHIE;
          else if (this.isMessageSubjectRelatedTO(IceTypes.ACCOUNT_TYPE.actPharmacy))
            regType = IceTypes.RegistrationTopics.rtPharmacy;
          else if (this.isMessageSubjectRelatedTO(IceTypes.ACCOUNT_TYPE.actPayer))
            regType = IceTypes.RegistrationTopics.rtPayer;

          let domToAdd = null;
          if (IceTypes.RegistrationTopics.rtVendorHIE == regType
            && this.domainToAdd[IceTypes.RegistrationTopics.rtVendorHIE] == null)
            domToAdd = this.domainToAdd[IceTypes.RegistrationTopics.rtVendorHIE] = new vendor();
          else if (IceTypes.RegistrationTopics.rtPharmacy == regType
            && this.domainToAdd[IceTypes.RegistrationTopics.rtPharmacy] == null)
            domToAdd = this.domainToAdd[IceTypes.RegistrationTopics.rtPharmacy] = new pharmacy();
          else if (IceTypes.RegistrationTopics.rtPayer == regType
            && this.domainToAdd[IceTypes.RegistrationTopics.rtPayer] == null)
            domToAdd = this.domainToAdd[IceTypes.RegistrationTopics.rtPayer] = new payer();
          else
            domToAdd = this.domainToAdd[regType];

          if (domToAdd != null) {
            if (domToAdd.entity_key == null || domToAdd.entity_key.length == 0) {
              domToAdd.entity_key = Iceutility.guid(true);
              domToAdd.offline_record_status = IceTypes.offlineRecStatus.offlineInsert;
              let ent = new entity();
              ent.entity_key = domToAdd.entity_key;
              ent.offline_record_status = IceTypes.offlineRecStatus.offlineInsert;
              domToAdd.ENTS.push(ent);
            }

            if (domToAdd.address_key == null || domToAdd.address_key.length == 0) {
              let ads = new address();
              ads.address_key = domToAdd.address_key = Iceutility.guid(true);
              ads.offline_record_status = IceTypes.offlineRecStatus.offlineInsert;
              domToAdd.ADS.push(ads);
            }
          }
        }
        this.onHeaderActionClick(event);
      }
      else if (event.buttonSettings.id != null && event.buttonSettings.id.indexOf(NewRequestForAppointment) >= 0) {
        this.proService.getProviders().subscribe(
          prodata => {
            if (Iceutility.isdefined(prodata)) {
              let gl = new managementguideline();

              gl.order_status_type = IceTypes.orderentrystatus.oestatusWaiting;
              gl.management_guideline_key = Iceutility.guid(true);
              gl.title = "Request for Appointment";
              gl.description = this.messageObj.message_body;
              gl.src_type = IceTypes.SourceType.srcTypeOfService;

              gl.OBSERVS.push(this.createobservation("Request for an appointment with:", "label1", "", IceTypes.RESULT_STATUS.rsFinal));

              let facOb = this.createobservation("Name of Hospital, Facility or Organization", "organization_name", "", IceTypes.RESULT_STATUS.rsNotObserved, "iceautocomplete");
              gl.OBSERVS.push(facOb);

              let proOb = this.createobservation("Last Name of Doctor", "last_name", "", IceTypes.RESULT_STATUS.rsNotObserved, "iceautocomplete");
              gl.OBSERVS.push(proOb);

              let dups = {};
              for (let ipro = 0; ipro < prodata.length; ipro++) {
                let pro: provider_index = prodata[ipro];
                if (pro == null) continue;
                if (dups[pro.trans_account] != null) continue;

                if (pro.account_type == IceTypes.ACCOUNT_TYPE.actProvider)
                  proOb.SUBTYPES.push(this.createsubtype(pro.getdisplayname(false), pro.trans_account, 0));
                else
                  facOb.SUBTYPES.push(this.createsubtype(pro.getdisplayname(true), pro.trans_account, 0));

                dups[pro.trans_account] = true;
              }

              this.messageObj.GLRULES.push(gl);

              if (this.messageSettings.rows[0].columns.length == 0)
                this.messageSettings.rows[0].columns = [];

              let surveysections: IcepanelsectionSettings[] = [];
              surveysections = surveysections.concat(this.showSureveyHeading(gl, IceTypes.ACCOUNT_TYPE.actPatient));
              surveysections = surveysections.concat(this.showSureveySections(gl.OBSERVS, gl.order_status_type));

              this.messageSettings.rows[0].columns.push(new IceexpansionpanelSettings("GLSurvey" + gl.management_guideline_key, gl.management_guideline_key, gl.title, "", surveysections, null, null, null, 0)
                .enableForm());

              setTimeout(() => {
                document.getElementById(SurveyStatus + gl.management_guideline_key).scrollIntoView();
              }, 500);
            }
          },
          error => {
            console.log(error);
          });
      }
      else if (event.buttonSettings.id != null && event.buttonSettings.id.indexOf(NewRequestForBenefits) >= 0) {
        if (this.messageObj.subject.toLowerCase().indexOf("vote") >= 0
          || this.messageObj.subject.toLowerCase().indexOf("ballot") >= 0) {
          debugger;
        }
        else if (this.messageObj.subject.toLowerCase().indexOf("nominate") >= 0) {
          debugger;
        }
        else {
          this.payerService.getPayers().subscribe(
            pyrdata => {
              if (Iceutility.isdefined(pyrdata)) {
                let gl = new managementguideline();

                gl.order_status_type = IceTypes.orderentrystatus.oestatusWaiting;
                gl.management_guideline_key = Iceutility.guid(true);
                gl.title = "Request for Subscription to Benefits";
                gl.description = this.messageObj.message_body;
                gl.src_type = IceTypes.SourceType.srcTypeOfService;

                gl.OBSERVS.push(this.createobservation("Subscribe for benefits with:", "label1", "", IceTypes.RESULT_STATUS.rsFinal));

                let pyrOb = this.createobservation("Name of Payer or Organization", "organization_name", "", IceTypes.RESULT_STATUS.rsNotObserved, "iceautocomplete");
                gl.OBSERVS.push(pyrOb);

                let dups = {};
                for (let ipyr = 0; ipyr < pyrdata.length; ipyr++) {
                  let pyr: payer_index = pyrdata[ipyr];
                  if (pyr == null) continue;
                  if (dups[pyr.trans_account] != null) continue;

                  pyrOb.SUBTYPES.push(this.createsubtype(pyr.getdisplayname(true), pyr.trans_account, 0));
                  dups[pyr.trans_account] = true;
                }

                this.messageObj.GLRULES.push(gl);

                if (this.messageSettings.rows[0].columns.length == 0)
                  this.messageSettings.rows[0].columns = [];

                let surveysections: IcepanelsectionSettings[] = [];
                surveysections = surveysections.concat(this.showSureveyHeading(gl, IceTypes.ACCOUNT_TYPE.actSubscriber));
                surveysections = surveysections.concat(this.showSureveySections(gl.OBSERVS, gl.order_status_type));

                this.messageSettings.rows[0].columns.push(new IceexpansionpanelSettings("GLSurvey" + gl.management_guideline_key, gl.management_guideline_key, gl.title, "", surveysections, null, null, null, 0)
                  .enableForm());

                setTimeout(() => {
                  document.getElementById(SurveyStatus + gl.management_guideline_key).scrollIntoView();
                }, 500);
              }
            },
            error => {
              console.log(error);
            });
        }
      }
      else if (event.buttonSettings.id != null && event.buttonSettings.id.indexOf(ImportContinue) >= 0) {
         if (this.messageObj.GLRULES.length > 0) {
          let ptDomain = "";
          let glS = this.messageObj.GLRULES.filter(g => g.trans_account.length > 0);
          if (glS.length > 0)
            ptDomain = glS[0].trans_account;

          if (ptDomain.length == 0) return;
          let gl: managementguideline = null;

          // Since we will be adding Vendor, Payer, and Pharmacy; let's modify this code
          glS = this.messageObj.GLRULES.filter(g => g.src_type == IceTypes.SourceType.srcTypeOfService);
          if (glS.length > 0)
            gl = glS[0];

          if (gl == null) return;

          let proRefs: provider_reference[] = [];
          let prosOb = gl.OBSERVS.filter(ob => ob.obx4_observation_subid == "organization_name"
            || ob.obx4_observation_subid == "last_name");
          for (let ipro = 0; ipro < prosOb.length; ipro++) {
            let pro = prosOb[ipro];
            if (pro == null) continue;

            try {
              let proVals = JSON.parse(pro.obx5_observation_value);
              if (proVals && Iceutility.isdefined(proVals.length) && proVals.length > 0) {
                let proDomainType = pro.obx4_observation_subid == "organization_name" ? IceTypes.ACCOUNT_TYPE.actFacility : IceTypes.ACCOUNT_TYPE.actProvider;
                let proDomain = proVals[0]["value"];
                let proRef = new provider_reference(null);
                proRef.provider_reference_key = Iceutility.guid(true);
                proRef.account_type = proDomainType;
                proRef.trans_account = proDomain;
                proRef.offline_record_status = IceTypes.offlineRecStatus.offlineInsert;
                proRefs.push(proRef);
              }
            }
            catch (e) {
              continue;
            }
          }

          let viewComp: ViewmessageComponent = this;
          this.ptService.insertUpdateProviders(ptDomain, proRefs).subscribe(
            data => {
              gl.trans_account = ptDomain;
              viewComp.onHeaderActionClick(event);
            },
            error => {
              console.log(error);
            });
        }
      }
      else if (event.buttonSettings.id != null && event.buttonSettings.id.indexOf(AppointmentContinue) >= 0) {
        if (this.messageObj.GLRULES.length > 0) {
          let ptDomain = "";
          let glS = this.messageObj.GLRULES.filter(g => g.trans_account.length > 0);
          if (glS.length > 0)
            ptDomain = glS[0].trans_account;

          if (ptDomain.length == 0) return;

          let key = event.buttonSettings.id.replace(AppointmentContinue, "");
          let gl: managementguideline = null;
          glS = this.messageObj.GLRULES.filter(g => g.management_guideline_key == key);
          if (glS.length > 0)
            gl = glS[0];

          if (gl == null) return;

          if (this.appointmentsToManage == null) return;

          let btnCtrl: IcecontrolSettings = event.buttonSettings;
          let pnl = this.getAppointmentPanel(gl.management_guideline_key);
          if (pnl == null) return;
          let frmGrp = pnl.getForm();
          if (frmGrp == null) return;
          if (frmGrp.valid == false) {
            // To do error message
            return;
          }

          let dtStart = frmGrp.get(DateOfAppointment + gl.management_guideline_key).value;
          let timeStart = frmGrp.get(TimeOfAppointment + gl.management_guideline_key).value;
          let telehlth = frmGrp.get(TelehealthAppointment + gl.management_guideline_key).value;
          let telehlthUrl = frmGrp.get(TelehealthUrlForAppointment + gl.management_guideline_key).value;

          let apts = this.appointmentsToManage.filter((a) => a.referral_from_key == gl.referral_from_key);
          if (apts.length == 0) return;

          let tempDate = Iceutility.GetLocalDate(Iceutility.GetDateText(dtStart, null, false) + " " + timeStart);
          let utcStart = Iceutility.ConvertToUTC(tempDate, true);
          let utcEnd = Iceutility.ConvertToUTC(Iceutility.addTime(new Date(tempDate), 0, 0, 30, 0), true);          

          apts[0].time_slot_start = utcStart;
          apts[0].telehealth = telehlth;
          apts[0].telehealth_url = telehlthUrl;
          apts[0].time_slot_end = utcEnd;

          let prosOb = gl.OBSERVS.filter(ob => ob.obx4_observation_subid == "organization_name"
            || ob.obx4_observation_subid == "last_name");
          for (let ipro = 0; ipro < prosOb.length; ipro++) {
            let pro = prosOb[ipro];
            if (pro == null) continue;

            try {
              let proVals = JSON.parse(pro.obx5_observation_value);
              if (proVals && Iceutility.isdefined(proVals.length) && proVals.length > 0) {
                let proDomainType = pro.obx4_observation_subid == "organization_name" ? IceTypes.ACCOUNT_TYPE.actFacility : IceTypes.ACCOUNT_TYPE.actProvider;
                let proDomain = proVals[0]["value"];
                // create an appointment
                let viewComp: ViewmessageComponent = this;
                this.proService.insertUpdateAppointment(apts[0], proDomain, ptDomain, proDomainType).subscribe(
                  data => {
                    gl.src_key = apts[0].appointment_key;
                    viewComp.onHeaderActionClick(event);
                  },
                  error => {
                    console.log(error);
                  });
                return;
              }
            }
            catch (e) {
              continue;
            }
          }
        }
      }
      else if (event.buttonSettings.id != null && event.buttonSettings.id.indexOf(BillingContinue) >= 0) {
        if (this.messageObj.GLRULES.length > 0) {
          let subDomain = "";
          let glS = this.messageObj.GLRULES.filter(g => g.trans_account.length > 0);
          if (glS.length > 0)
            subDomain = glS[0].trans_account;

          if (subDomain.length == 0) return;

          let key = event.buttonSettings.id.replace(BillingContinue, "");
          let gl: managementguideline = null;
          glS = this.messageObj.GLRULES.filter(g => g.management_guideline_key == key);
          if (glS.length > 0)
            gl = glS[0];

          if (gl == null) return;

          if (this.billsToManage == null) return;

          let btnCtrl: IcecontrolSettings = event.buttonSettings;
          let pnl = this.getAppointmentPanel(gl.management_guideline_key);
          if (pnl == null) return;
          let frmGrp = pnl.getForm();
          if (frmGrp == null) return;
          if (frmGrp.valid == false) {
            // To do error message
            return;
          }

          /*
          let dtStart = frmGrp.get(DateOfAppointment + gl.management_guideline_key).value;
          let timeStart = frmGrp.get(TimeOfAppointment + gl.management_guideline_key).value;
          let telehlth = frmGrp.get(TelehealthAppointment + gl.management_guideline_key).value;
          let telehlthUrl = frmGrp.get(TelehealthUrlForAppointment + gl.management_guideline_key).value;

          let apts = this.appointmentsToManage.filter((a) => a.referral_from_key == gl.referral_from_key);
          if (apts.length == 0) return;

          let tempDate = Iceutility.GetLocalDate(Iceutility.GetDateText(dtStart, null, false) + " " + timeStart);
          let utcStart = Iceutility.ConvertToUTC(tempDate, true);
          let utcEnd = Iceutility.ConvertToUTC(Iceutility.addTime(new Date(tempDate), 0, 0, 30, 0), true);

          apts[0].time_slot_start = utcStart;
          apts[0].telehealth = telehlth;
          apts[0].telehealth_url = telehlthUrl;
          apts[0].time_slot_end = utcEnd;

          let prosOb = gl.OBSERVS.filter(ob => ob.obx4_observation_subid == "organization_name"
            || ob.obx4_observation_subid == "last_name");
          for (let ipro = 0; ipro < prosOb.length; ipro++) {
            let pro = prosOb[ipro];
            if (pro == null) continue;

            try {
              let proVals = JSON.parse(pro.obx5_observation_value);
              if (proVals && Iceutility.isdefined(proVals.length) && proVals.length > 0) {
                let proDomainType = pro.obx4_observation_subid == "organization_name" ? IceTypes.ACCOUNT_TYPE.actFacility : IceTypes.ACCOUNT_TYPE.actProvider;
                let proDomain = proVals[0]["value"];
                // create an appointment
                let viewComp: ViewmessageComponent = this;
                this.proService.insertUpdateAppointment(apts[0], proDomain, ptDomain, proDomainType).subscribe(
                  data => {
                    gl.src_key = apts[0].appointment_key;
                    viewComp.onHeaderActionClick(event);
                  },
                  error => {
                    console.log(error);
                  });
                return;
              }
            }
            catch (e) {
              continue;
            }
          }
          */
        }
      }
    }
    catch (e) {
      console.log(e);
    }
  }

  public onControlChange(event) {
    if (Iceutility.isdefined(event.selectSettings) && event.selectSettings.id.indexOf("country") >= 0) {
      this.dobControl.properties.dateFormat = this.loginSvc.getLocaleFromCountryCode(event.value);
      /// TODO: change this. OnChanges trigger is not working.
      this.controls[8].controls[0].properties = JSON.parse(JSON.stringify(this.dobControl.properties));
      this.controls[8].controls[0].getFormControl().setValue("date change");
    }
  }

  onAttachmentRemoveClick(event): void {
    if (Iceutility.isdefined(event.upload.uuid)) {
      let filUploaded: File = event;
      if (filUploaded != null) {
        this.messageService.removeMessageAttachment(this.appSvc.getCurrentAccount(),
          this.appSvc.getCurrentAccountType(),
          this.messageObj.message_key,
          IceTypes.SourceType.srcMiscellaneousForms,
          this.attachmentMap[filUploaded["upload"].uuid]).subscribe(data => {
            // update
            let index = Iceutility.getObjectIndexFromArray(this.messageObj.ATTACHMENTS, "external_data_key", this.attachmentMap[filUploaded["upload"].uuid]);
            if (index >= 0)
              this.messageObj.ATTACHMENTS.splice(index, 1);

            this.attachmentsDataSource.data = this.messageObj.ATTACHMENTS;
            console.log("File successfully removed");
          }, error => {
            console.log(error);
          });
      }
      if (this.messageObj.ATTACHMENTS.length == 0) this.dropzoneAttachmentCtrl.properties.height = '200px';
    }
    
  }

  onAttachmentUploadSuccessClick(event): void {
    if (Iceutility.isdefined(event) && event.length > 0) {
      let filUploaded: File = event[0];

      if (filUploaded && event.length > 1) {
        let extdataAry: externaldata[] = <externaldata[]>this.messageService.geticexdocumentobjects(event[1], ["EXTERNAL_DATA"])
        if (extdataAry == null || extdataAry.length == 0) {
          this.showErrorMessage("An error occurred while uploading the file");
          return;
        };

        extdataAry[0]["uuid"] = filUploaded["upload"].uuid;
        this.messageObj.ATTACHMENTS.push(extdataAry[0]);
        this.attachmentsDataSource.data = this.messageObj.ATTACHMENTS;
        this.attachmentMap[filUploaded["upload"].uuid] = extdataAry[0].external_data_key;        
      }
    }    
  }

  private showHideProgressSpinner(show: boolean = true) {
    this.getFirstPanel().setLoading(show);
  }

  // this gets called when file is downloaded or error occurs during download
  private onFileDownload() {
    this.showHideProgressSpinner(false);
  }

  private showErrorMessage(message: string = "An error while processing your request") {
    this.messageService.logMessage(IceTypes.LOGTYPE.ltError, message);
    window.scrollTo(0, 0);
  }
}
